/* eslint no-else-return: "warn" */
/* eslint guard-for-in: "warn" */
/* eslint complexity: ["error", 3000] */
/* eslint max-statements: ["error", 3000] */

// Please try to reduce line count in this file if possible.  Import is your friend.
/* eslint max-lines: ["error", 5200] */

import { HiddenQuestionTypes } from '@jotforminc/form-common';
import { FORM_TEXTS } from '@jotforminc/constants';
import { closest } from '@jotforminc/utils';
import DomPurify from 'dompurify';

import './polyfill';

import {
  cardSize, deviceSize, addClass,
  removeClass, forEach,
  hasTouch, map, hasClass, createInput,
  enableDisableDOMElements, calculateOrientationType,
  translateDefaultCardFormTexts, getDeviceType, getBrowserProperties, translateComponentFields, getElementsByFocus
} from './utils';

import { TOOLTIP_TYPES } from './constants';
import ProgressClass from './progress';
import Overlay from './overlay';
import Patch from './patch';
import Address from './address';
import Matrix from './matrix';
import Email from './email';
import EmojiSlider from './emojiSlider';
import FeedbackIframeMessager from './feedbackIframeMessager';
import Fullscreen from './Fullscreen';

import OptionsBase from './optionsBase';
import Dropdown from './dropdown';
import Textarea from './textarea';
import Payment from './payment';
import DatetimeHandler from './datetime';
import Storage from './storage';
import EmbedOptions from './embedOptions';
import SaveAndContinueLater, { defaultIcon, savedIcon, errorIcon } from './saveAndContinueLater';
import CardHint from './cardHint';

/* eslint-disable */
if (typeof global.createNewEvent !== "function") {
  global.createNewEvent = function(eventName) {
    if(typeof(global.Event) === 'function') {
        var event = new global.Event(eventName);
    }else{
        var event = document.createEvent('Event');
        event.initEvent(eventName, true, true);
    }

    return event;
  }
}
/* eslint-enable */

if (typeof String.prototype.locale === 'undefined') {
  String.prototype.locale = function () { // eslint-disable-line
    return this.toString();
  };
}

const fieldRelatedNavigationKeyCodes = {
  INPUT: [37, 39],
  TEXTAREA: [13, 37, 39]
};

const NonInputFields = ['control_image', 'control_text'];

export default class Cards {
  constructor(props) {
    this.bindFullScreenMode = this.bindFullScreenMode.bind(this);
    this.bindCardClickEvents = this.bindCardClickEvents.bind(this);
    this.setFormMode = this.setFormMode.bind(this);
    this.setCardIndex = this.setCardIndex.bind(this);
    this.setCardMode = this.setCardMode.bind(this);
    this.selectQuestion = this.selectQuestion.bind(this);
    this.selectNextQuestion = this.selectNextQuestion.bind(this);
    this.selectPreviousQuestion = this.selectPreviousQuestion.bind(this);
    this.bindResizeEvent = this.bindResizeEvent.bind(this);
    this.recalculateLayout = this.recalculateLayout.bind(this);
    this.recalculateSmartEmbedLayout = this.recalculateSmartEmbedLayout.bind(this);
    this.getVisibleIndex = this.getVisibleIndex.bind(this);
    this.updateCardIndexes = this.updateCardIndexes.bind(this);
    this.updateCardLabels = this.updateCardLabels.bind(this);
    this.getCardLabels = this.getCardLabels.bind(this);
    this.bindPrevNextButtonsClick = this.bindPrevNextButtonsClick.bind(this);
    this.bindInputChange = this.bindInputChange.bind(this);
    this.bindSelectChange = this.bindSelectChange.bind(this);
    this.bindKeyUpEvent = this.bindKeyUpEvent.bind(this);
    this.bindDragPage = this.bindDragPage.bind(this);
    this.bindFormSubmit = this.bindFormSubmit.bind(this);
    this.bindStartButton = this.bindStartButton.bind(this);
    this.mouseDown = this.mouseDown.bind(this);
    this.mouseUp = this.mouseUp.bind(this);
    this.mouseMove = this.mouseMove.bind(this);
    this.onWheel = this.onWheel.bind(this);
    this.bindInputFocus = this.bindInputFocus.bind(this);
    this.addScrollLeftDelta = this.addScrollLeftDelta.bind(this);
    this.getScrollLeft = this.getScrollLeft.bind(this);
    this.getTotalWidth = this.getTotalWidth.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.validateCard = this.validateCard.bind(this);
    this.onFieldCorrected = this.onFieldCorrected.bind(this);
    this.onFieldErrored = this.onFieldErrored.bind(this);
    this.onFormOverviewClicked = this.onFormOverviewClicked.bind(this);
    this.onProgressItemSelected = this.onProgressItemSelected.bind(this);
    this.shakeCard = this.shakeCard.bind(this);
    this.setCardVisibility = this.setCardVisibility.bind(this);
    this.onFieldVisibilityChanged = this.onFieldVisibilityChanged.bind(this);
    this.onRequireField = this.onRequireField.bind(this);
    this.onEnableDisableField = this.onEnableDisableField.bind(this);
    this.updateCardProgressItem = this.updateCardStatus.bind(this);
    this.focusToFirstInput = this.focusToFirstInput.bind(this);
    this.focusToFirstError = this.focusToFirstError.bind(this);
    this.getNearestCardIndexInScrollMode = this.getNearestCardIndexInScrollMode.bind(this);
    this.renderReCaptcha = this.renderReCaptcha.bind(this);
    this.recaptchaCallback = this.recaptchaCallback.bind(this);
    this.hcaptchaCallback = this.hcaptchaCallback.bind(this);
    this.onCreditCardAddressVisibilityChanged = this.onCreditCardAddressVisibilityChanged.bind(this);
    this.repositionActionButtons = this.repositionActionButtons.bind(this);
    this.setCardActionMode = this.setCardActionMode.bind(this);
    this.shortenHeaders = this.shortenHeaders.bind(this);
    this.hideHeader = this.hideHeader.bind(this);
    this.showHeader = this.showHeader.bind(this);
    this.onCalendarSelected = this.onCalendarSelected.bind(this);
    this.initBackgroundImageLoader = this.initBackgroundImageLoader.bind(this);
    this.handleBackgroundVideo = this.handleBackgroundVideo.bind(this);
    this.onCalendarInit = this.onCalendarInit.bind(this);
    this.bindChangeEventForPressEnter = this.bindChangeEventForPressEnter.bind(this);
    this.getFormData = this.getFormData.bind(this);
    this.prepareReviewMarkup = this.prepareReviewMarkup.bind(this);
    this.showFormPreview = this.showFormPreview.bind(this);
    this.replaceSubmitWithReviewAndSubmit = this.replaceSubmitWithReviewAndSubmit.bind(this);
    this.setFieldIsFilledIfHasValue = this.setFieldIsFilledIfHasValue.bind(this);
    this.getTotalWelcome = this.getTotalWelcome.bind(this);
    this.calculateAvailableHeightForFields = this.calculateAvailableHeightForFields.bind(this);
    this.calculateCardsHeight = this.calculateCardsHeight.bind(this);
    this.calculateCardHeight = this.calculateCardHeight.bind(this);
    this.onFileUploadChanged = this.onFileUploadChanged.bind(this);
    this.fillInitialValuesForEditMode = this.fillInitialValuesForEditMode.bind(this);
    this.checkCardsIfFilled = this.checkCardsIfFilled.bind(this);
    this.getSectionHeaderForIndex = this.getSectionHeaderForIndex.bind(this);
    this.arrangeSectionHeaders = this.arrangeSectionHeaders.bind(this);
    this.updateFormHeader = this.updateFormHeader.bind(this);
    this.recalculateBackgroundStyle = this.recalculateBackgroundStyle.bind(this);
    this.checkAndSetDeviceType = this.checkAndSetDeviceType.bind(this);
    this.checkHeaderSubHeaderCharLimits = this.checkHeaderSubHeaderCharLimits.bind(this);
    this.onLocationHashChange = this.onLocationHashChange.bind(this);
    this.isVisibleIndex = this.isVisibleIndex.bind(this);
    this.getFirstVisibleIndex = this.getFirstVisibleIndex.bind(this);
    this.getLastVisibleIndex = this.getLastVisibleIndex.bind(this);
    this.setMobilePrevNextQuestionButtons = this.setMobilePrevNextQuestionButtons.bind(this);
    this.setDropdownInitialValues = this.setDropdownInitialValues.bind(this);
    this.disableTransitions = this.disableTransitions.bind(this);
    this.translateSectionHeader = this.translateSectionHeader.bind(this);
    this.onFormTranslated = this.onFormTranslated.bind(this);
    this.updateMatrixLayout = this.updateMatrixLayout.bind(this);
    this.handleKeyboardTabs = this.handleKeyboardTabs.bind(this);
    this.handleFullScreenToggle = this.handleFullScreenToggle.bind(this);
    this.bindMobileValidations = this.bindMobileValidations.bind(this);
    this.initMobileVersion = this.initMobileVersion.bind(this);
    this.doObjectsCollide = this.doObjectsCollide.bind(this);
    this.attachComponentClassToCard = this.attachComponentClassToCard.bind(this);
    this.showInputTooltip = this.showInputTooltip.bind(this);
    this.clearAddressFields = this.clearAddressFields.bind(this);
    this.toggleFullScreenMode = this.toggleFullScreenMode.bind(this);
    this.toggleFullScreenDisplayMode = this.toggleFullScreenDisplayMode.bind(this);
    this.getCurrentCard = this.getCurrentCard.bind(this);
    this.autoSelectNextQuestion = this.autoSelectNextQuestion.bind(this);
    this.handleFeedbackButtonProgress = this.handleFeedbackButtonProgress.bind(this);
    this.updateFeedbackEmbedHeight = this.updateFeedbackEmbedHeight.bind(this);
    this.bindChangeEventForNextButtons = this.bindChangeEventForNextButtons.bind(this);
    this.findEmailAnswer = this.findEmailAnswer.bind(this);
    this.calculateWelcomeSize = this.calculateWelcomeSize.bind(this);
    this.createDatetimeReviewString = this.createDatetimeReviewString.bind(this);
    this.showProgress = this.showProgress.bind(this);
    this.hiddenSubmit = this.hiddenSubmit.bind(this);
    this.handleFormSubmitError = this.handleFormSubmitError.bind(this);
    this.setInitialSelectionForMatrixSliders = this.setInitialSelectionForMatrixSliders.bind(this);
    this.asyncInitSaveAndContinueLaterFlow = this.asyncInitSaveAndContinueLaterFlow.bind(this);
    this.checkConditionOnCurrentCard = this.checkConditionOnCurrentCard.bind(this);
    this.onSCLStateChange = this.onSCLStateChange.bind(this);
    this.closeTimezonePicker = this.closeTimezonePicker.bind(this);
    this.isSaveAndContinueLaterActivated = props.isSaveAndContinueLaterActivated || props.isSSOProtected;
    this.formID = props.formID;
    this.tranlatedTexts = props.tranlatedTexts;
    this.erroredCards = [];
    this.isProduction = props.isProduction || true; // work around for cached forms.
    this.apiURL = props.apiURL || 'https://api.jotform.com'; // work around for cached forms.
    this.continueLater = {
      active: this.isContinueLaterActivated,
      useStorage: false,
      lastAnswers: false
    }; // to activate save&continue
    this.storageEngine = new Storage();
    this.patch = new Patch({
      onSubmit: this.onSubmit,
      onFieldCorrected: this.onFieldCorrected,
      onFieldErrored: this.onFieldErrored,
      onFieldVisibilityChanged: this.onFieldVisibilityChanged,
      onRequireField: this.onRequireField,
      onEnableDisableField: this.onEnableDisableField,
      onCreditCardAddressVisibilityChanged: this.onCreditCardAddressVisibilityChanged,
      onCalendarSelected: this.onCalendarSelected,
      onCalendarInit: this.onCalendarInit,
      captchaMode: props.captchaMode,
      onFileUploadChanged: this.onFileUploadChanged,
      formID: props.formID,
      storageEngine: this.storageEngine,
      continueLater: this.continueLater,
      showTooltip: this.showInputTooltip
    });

    this.addressTypeSuffixMap = {
      country: 'country',
      administrative_area_level_1: 'state',
      postal_code: 'postal',
      locality: 'city',
      street: 'addr_line1',
      street2: 'addr_line2',
      searchField: 'addr_search'
    };
    if (this.isSaveAndContinueLaterActivated) {
      this.initSaveAndContinueLater();
    }

    if (props.useJotformSign && props.useJotformSign.value === 'Yes') {
      global.useJotformSign = props.useJotformSign.value;
    }

    this.browserProperties = getBrowserProperties();

    // This parameter will be updated as true at build_source if the form is embedded via script.
    this.jsForm = false;

    this.hasWelcome = props.formMode === 'welcome';

    if (false) { // eslint-disable-line
      this.pressEnterHint = new CardHint({ timeout: 3000, className: 'js-pressEnterHint' });
    }

    /* This method is just for internal usage! we will use it in random-cards page */
    if (global.location.href.indexOf('autoNextCards=1') > -1) {
      const reallySelectNextQuestion = () => {
        if (this.layoutParams.formMode === 'welcome') {
          this.setFormMode('form');
        } else {
          this.selectNextQuestion(true);
        }
      };
      setInterval(reallySelectNextQuestion, 3000);
    }

    this.isOpenedOnJotFormMobileApp = global.location.href.indexOf('jotformNext=1') > -1;

    this.init(props);
  }

  init(props) {
    const isTouchDevice = hasTouch();

    this.arrangeSectionHeaders(props.welcomePageProps, props.sectionHeaders);
    this.layoutElements = {
      cardAnimationWrapper: document.getElementById('cardAnimationWrapper'),
      welcomeCardBackground: document.querySelector('.jfForm-background-mask'),
      startButton: document.getElementById('jfCard-welcome-start'),
      previousButton: document.getElementById('jfCard-welcome-previous'),
      welcomeWrapper: document.querySelector('.jfWelcome-wrapper'),
      featureBadge: document.querySelector('.jfWelcome-badge--container'),
      welcomeContainer: document.querySelector('.jfWelcome'),
      welcomeHeaderContainer: document.getElementById('header_welcomePage'),
      welcomeSubHeaderContainer: document.querySelector('.jfWelcome-description'),
      welcomeSectionInfoText: document.querySelector('.jfWelcome-sectionInfo-text'),
      welcomeSectionInfoQuestionCount: document.querySelector('.jfWelcome-sectionInfo-questionCount'),
      logoContainer: document.querySelector('.jfForm-logo'),
      progressWrapper: document.querySelector('.jfProgress#cardProgress'),
      progressContainer: document.querySelector('.jfProgress-infoContent'),
      mobileNavigationWrapper: document.querySelector('.jsMobileNavigation'),
      mobileNextButton: document.querySelector('.jsMobileNext'),
      mobilePrevButton: document.querySelector('.jsMobilePrev'),
      mobileSubmitButton: document.querySelector('.jsMobileSubmit'),
      mobileUseJFSignButton: document.querySelector('.forMobileNav.useJotformSign-button'),
      mobileProgressInfo: document.querySelector('.jfProgress-info'),
      fullScreenProxy: document.getElementById('jfQuestion-proxy'),
      formWrapper: document.querySelector('.jfForm-all'),
      overlayWrapper: document.querySelector('.js-overlayWrapper'),
      staticItems: document.querySelector('.jStaticItems'),
      backgroundVideoPlayer: document.querySelector('#video-background')
    };

    const wrappers = map(document.querySelectorAll('.jfCard-wrapper'), p => p);
    const cards = map(document.querySelectorAll('.jfCard'), p => p);
    const indexes = map(document.querySelectorAll('.jfCard-index'), p => p);
    const formlines = map(document.querySelectorAll('.form-line'), p => p);
    const pressEnterContainers = map(document.querySelectorAll('.jfPressEnter'), p => p);
    const isEditMode = this.isEditMode();
    const ownerView = !!props.ownerView;

    const isHiddenField = field => {
      let isHidden = !!field.isHidden;
      if (isEditMode && ownerView && field.widgetType !== 'direct_embed') {
        isHidden = false;
      }

      if (HiddenQuestionTypes.indexOf(field.type) !== -1 && !isHidden) {
        isHidden = true;
      }

      if (field.type && field.type === 'control_checkbox' && field.isHidden && field.sheetField && field.submissionWidget) {
        isHidden = true;
      }

      return isHidden;
    };
    this.cards = props.questions.map((q, i) => {
      const formLine = formlines.find(p => p.id === `id_${q.id}`);
      return {
        question: q,
        cardContainer: cards[i],
        cardToolbar: wrappers[i].querySelector('.jfToolbar'),
        wrapperContainer: wrappers[i],
        indexContainer: indexes[i],
        pressEnterContainer: pressEnterContainers[i],
        fieldContainer: formLine.querySelector(".jfQuestion-fields:not([class*='js-']):not([class*='jfQuestion-fields--donation']), .jfQuestion-fields.js-productModuleWrapper"),
        questionContainer: cards[i].querySelector('.jfCard-question'),
        formLine,
        isHidden: isHiddenField(q),
        isReadOnly: q.isReadOnly ? true : false,
        hideSingleProduct: q.hideSingleProduct ? true : false,
        actionButtonsWrapper: cards[i].querySelector('.jfCard-actions'),
        actionsButtons: {
          prev: cards[i].querySelector('.jfCard-actions .forPrev'),
          next: cards[i].querySelector('.jfCard-actions .forNext'),
          submit: cards[i].querySelector('.jfCard-actions .forSubmit'),
          mode: 'middle' // first, last, middle, submit,
        },
        prevCard: null
      };
    });

    this.cards.forEach(_card => {
      const card = _card;
      card.validate = this.validateCard.bind(this, card);
    });

    if (cards.length > 0) {
      this.cards[this.cards.length - 1].hasSubmit = true;
    }

    const cardLabels = this.getCardLabels();
    this.cards = Payment.populateCards(this.cards, cardLabels);

    this.paymentsMergedCards = this.cards.reduce((result, current) => {
      const newResult = result;
      if (newResult[current.question.qid]) {
        newResult[current.question.qid].push(current);
      } else {
        newResult[current.question.qid] = [current];
      }
      return newResult;
    }, {});

    this.updateCardLabels();
    this.layoutParams = {
      questions: props.questions,
      currentCardSize: cardSize.cardwidthxl,
      leftMargin: 0,
      currentCardIndex: this.cards.findIndex(p => !p.isHidden),
      cardMode: 'single',
      formMode: null,
      cardScrollScale: 0.6,
      scaleFactor: 1,
      scrollLeftExtra: 0,
      resolutionType: '', // mobile, tablet, desktop according to current resolution it'll change on resize events
      deviceType: getDeviceType().toLowerCase(), // This is initial device type, it won't change on resolution changes.
      browserName: this.browserProperties.browserName,
      osName: this.browserProperties.osName,
      forTemplate: props.forTemplate,
      hasTouch: isTouchDevice || this.isPreviewMode,
      reviewBeforeSubmit: props.reviewBeforeSubmit,
      globalCardScaleFactor: 1,
      isFeedbackEmbed: document.location.search.indexOf('feedbackEmbed') > -1,
      allQuestions: props.allQuestions,
      smartEmbedMaxHeight: 264,
      isEditMode,
      isFullScreenMode: false,
      isFeedbackEmbedButton: this.isFeedbackEmbedButton,
      fullscreenForm: props.fullscreenMode,
      isEmbed: global.parent !== global
    };

    this.minLabelFontSize = 18;
    this.minDescFontSize = 12;

    this.ownerPercentage = props.ownerPercentage ? parseInt(props.ownerPercentage, 10) : false;
    this.initMobileVersion();
    addClass(document.body, `is${getDeviceType()}`);
    if (props.isSSOProtected) {
      addClass(document.body, 'isSSOProtected');
    }
    if (this.layoutParams.isFeedbackEmbed) {
      this.initializeFeedbackEmbedMode();
    }
    if (this.layoutParams.isFeedbackEmbedButton) {
      this.hwFeedbackEmbed = new FeedbackIframeMessager({ formID: this.formID });
      this.initializeHWFeedbackEmbedButton();
    }
    Cards.layoutParams = this.layoutParams;

    this.options = new OptionsBase({
      cards: this.cards,
      layoutParams: this.layoutParams,
      validateCard: this.validateCard,
      isPreviewMode: this.isPreviewMode
    });

    this.dropdown = new Dropdown({
      cards: this.cards,
      layoutParams: this.layoutParams,
      validateCard: this.validateCard,
      isPreviewMode: this.isPreviewMode
    });

    this.address = new Address({
      cards: this.cards,
      layoutParams: this.layoutParams,
      setFieldIsFilledIfHasValue: this.setFieldIsFilledIfHasValue,
      updateFeedbackEmbedHeight: this.updateFeedbackEmbedHeight
    });

    this.datetimeHandler = new DatetimeHandler({
      cards: this.cards,
      hasTouch: this.layoutParams.hasTouch,
      deviceType: this.layoutParams.deviceType
    });

    this.overlay = new Overlay({
      questions: this.layoutParams.questions
    });

    // Initialize new textareas as pen editor
    this.cards = this.cards.map(card => {
      if (!card.question || card.question.type !== 'control_textarea' || !card.fieldContainer || card.fieldContainer.getAttribute('data-render-type') !== 'mde') return card;
      return { ...card, markdownEditor: new Textarea(card, this.layoutParams.browserName, this.layoutParams.osName) };
    });

    this.progress = new ProgressClass({
      items: this.cards.map(p => ({ label: p.label, question: p.question })),
      cards: this.cards,
      onFormOverviewClicked: this.onFormOverviewClicked,
      onItemSelected: this.onProgressItemSelected,
      hiddenIndexes: this.cards.map(p => p.isHidden),
      deviceType: this.layoutParams.deviceType,
      isFeedbackEmbedButton: this.isFeedbackEmbedButton,
      isSaveAndContinueLaterActivated: this.isSaveAndContinueLaterActivated,
      isFormProgressVisible: props.isFormProgressVisible
    });

    this.bindCardClickEvents();
    this.checkAndSetDeviceType();
    // Check if location has a question hash
    const questionIdFromHash = this.getQuestionIdFromUrlHash(global.location.href);
    let initialCardIndex = this.layoutParams.currentCardIndex;
    if (questionIdFromHash) {
      const questionIndexFromHash = parseInt(questionIdFromHash, 10) - 1;
      initialCardIndex = this.isVisibleIndex(questionIndexFromHash) ? questionIndexFromHash : initialCardIndex;
    }
    const initialFormMode = ((questionIdFromHash && parseInt(questionIdFromHash, 10) !== 1) ? 'form' : props.formMode) || 'welcome';
    this.setCardIndex(initialCardIndex, false, true);
    this.setFormMode(initialFormMode, true);
    this.updateFormHeader(this.getSectionHeaderForIndex(initialCardIndex));
    this.bindResizeEvent();
    setTimeout(() => this.recalculateLayout());
    this.recalculateBackgroundStyle();
    this.bindPrevNextButtonsClick();

    // If all fields hidden on init and being visible conditionally with taking condition parameter from url, then take some time and check it
    if (window.location.search !== '') {
      setTimeout(() => {
        const newInitialCardIndex = this.cards.findIndex(p => !p.isHidden);
        // Bugfix#2418466, be sure that the current index points the real one once again.
        if (newInitialCardIndex !== -1 && newInitialCardIndex !== this.layoutParams.currentCardIndex) {
          this.setCardIndex(newInitialCardIndex, false, true);
          this.updateFormHeader(this.getSectionHeaderForIndex(newInitialCardIndex));
        }
      }, 100);
    }

    this.isPrefillCompleted = false;
    document.addEventListener('PrefillCompleted', () => { this.isPrefillCompleted = true; });

    this.isPrepopulationCompleted = false;
    document.addEventListener('PrepopulationCompleted', () => { this.isPrepopulationCompleted = true; });

    // question prepopulations(URL Populate) triggers change, delay bind to end of ready function in Jotform.init()
    document.addEventListener('JotformReady', this.bindInputChange);
    this.bindSelectChange();
    this.bindKeyUpEvent();
    this.bindDragPage();

    const onLoad = () => {
      if (this.isFullscreenFormEnabled) {
        this.FS = new Fullscreen();
        const target = document.documentElement;

        const fn = () => {
          addClass(document.body, 'fsOpenedOnce');
          this.FS.request();
          target.removeEventListener('click', fn);
          this.bindStartButton();
          target.click();
        };
        target.addEventListener('click', fn);

        const toggle = document.getElementById('fullscreen-toggle');
        if (toggle) {
          toggle.addEventListener('click', this.FS.toggle);
        }
      } else {
        this.bindStartButton();
      }

      if (window.Sentry && (!global.JotForm || !global.JotForm.isNewForms)) {
        const sentryConfig = { // ignore common browser extensions, plugins and only allow jotform domain errors
          dsn: 'https://abc78a66d1bf4f77bfb7e3469cef2658@sentry.io/291077',
          enviroment: 'production',
          whitelistUrls: [
            /https?:\/\/.*jotform\.com/,
            /https?:\/\/cdn\.jotfor\.ms/
          ],
          integrations: [
          /* global Sentry */
            new Sentry.Integrations.GlobalHandlers({
              onunhandledrejection: false
            })
          ],
          blacklistUrls: [
            // Facebook flakiness
            /graph\.facebook\.com/i,
            // Facebook blocked
            /connect\.facebook\.net\/en_US\/all\.js/i,
            // Woopra flakiness
            /eatdifferent\.com\.woopra-ns\.com/i,
            /static\.woopra\.com\/js\/woopra\.js/i,
            // Chrome extensions
            /extensions\//i,
            /^chrome:\/\//i,
            // Other plugins
            /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
            /webappstoolbarba\.texthelp\.com\//i,
            /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
            /tinymce/i
          ],
          ignoreErrors: [
            // Random plugins/extensions
            'top.GLOBALS',
            // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error. html
            'originalCreateNotification',
            'canvas.contentDocument',
            'MyApp_RemoveAllHighlights',
            'http://tt.epicplay.com',
            'Can\'t find variable: ZiteReader',
            'jigsaw is not defined',
            'ComboSearch is not defined',
            'http://loading.retry.widdit.com/',
            'atomicFindClose',
            // Facebook borked
            'fb_xd_fragment',
            // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
            // reduce this. (thanks @acdha)
            // See http://stackoverflow.com/questions/4113268
            'bmi_SafeAddOnload',
            'EBCallBackMessageReceived',
            // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
            'conduitPage',
            'tinymce',
            // Common error caused by test software on a specific chrome version
            'GetScreenshotBoundingBox',
            'for=',
            // Error generated by a bug in auto-fill library from browser
            // https://github.com/getsentry/sentry/issues/5267
            /Blocked a frame with origin/,
            // See https://stackoverflow.com/questions/49384120
            /ResizeObserver loop limit exceeded/,
            'ResizeObserver loop completed with undelivered notifications.'
          ],
          beforeSend: event => {
            // whitelistUrls paramater is unreliable
            // do not collect errors from source code embed
            if (window.parent === window && !event.request.url.match(/(https?:\/\/.*jotform\.com)|(https?:\/\/cdn\.jotfor\.ms)/)) {
              return undefined;
            }

            // do not collect errors from embedded forms
            if (window.location.href && !window.location.href.match(/(https?:\/\/.*jotform\.com)|(https?:\/\/cdn\.jotfor\.ms)/)) {
              return null;
            }

            // Do not log errors that comes from the facebook browser
            if (window.navigator.userAgent.indexOf('FB_IAB') !== -1) {
              return null;
            }

            return event;
          }
        };

        window.Sentry.init(sentryConfig);
      }

      this.recalculateLayout();
      this.calculateInitialCardHeight();
    };

    if (document.readyState === 'complete') {
      onLoad();
    } else {
      window.addEventListener('load', onLoad);
    }

    this.bindTouchSwipeEvents();
    this.bindInputFocus();
    this.bindFocusOnMobileWithKeyboard();
    this.repositionActionButtons();
    this.setMobilePrevNextQuestionButtons(this.layoutParams.currentCardIndex);
    this.renderReCaptcha(props.captchaMode);
    this.updateCardIndexes();
    this.bindChangeEventForPressEnter();
    this.bindHashChangeEvent();
    // lets loop cards and please add your necessary code to here don't create new loop!
    forEach(this.cards, card => {
      this.attachComponentClassToCard(card);
      this.checkCardIfMoveAutomatically(card);

      if (this.isAccessibleForm) {
        const isCurrentCard = card.question?.id === this.currentCard?.question?.id;
        // accessibility: set [tabindex="-1"] to non-visible card elements
        this.setCardTabIndex({ card, tabIndex: isCurrentCard ? 0 : -1 });
      }
    });

    this.handleFullScreenToggle();
    if (this.layoutParams.deviceType === 'mobile') {
      this.bindMobileValidations();
    }
    // delay transitions for initial load
    if (this.layoutParams.formMode === 'form') {
      setTimeout(() => {
        this.enableTransitions();
      }, 100);
    }

    this.initBackgroundImageLoader();
    this.handleBackgroundVideo();

    if (props.reviewBeforeSubmit) {
      this.replaceSubmitWithReviewAndSubmit();
    } else {
      this.bindFormSubmit();
    }

    // update card isFilled status
    this.checkCardsIfFilled(this.cards);

    global.onEditModeCompleted = data => {
      this.cards.forEach(this.fillInitialValuesForEditMode);
      this.clearAddressFields();
      this.setDropdownInitialValues();
      this.checkCardsIfFilled(this.cards);
      if (data && data.continueCardIndex) {
        this.setCardIndex(data.continueCardIndex, false, true);
        this.showProgress();
      }
    };

    setTimeout(() => {
      this.isAdmin = global.JotForm && global.JotForm.isAdmin;

      this.bindFullScreenMode();
      this.setDropdownInitialValues();
      this.checkCardsIfFilled(this.cards);
    }, 100);

    this.embedOptions = new EmbedOptions(this);

    if (global.JotForm.sessionID && this.isSaveAndContinueLaterActivated && this.saveAndContinueLater) {
      this.saveAndContinueLater.continue();
    }

    // experiment for single question embeds
    if (this.layoutParams.isEmbed && this.layoutParams.questions.length === 1) {
      addClass(document.querySelector('body'), 'singleQuestion');
    }

    document.addEventListener('resize', this.calculateWelcomeSize);
  }

  initMobileVersion() {
    const isMobile = this.layoutParams.deviceType === 'mobile';
    if (!isMobile) { return; }

    // Disabling smart embed css on mobile devices
    global.document.body.classList.remove('isSmartEmbed');

    let newCardFormMobile = '0';
    const formFooter = document.querySelector('.formFooter-content');
    if (isMobile) {
      if (this.layoutElements.mobileNavigationWrapper) {
        this.layoutElements.mobileNavigationWrapper.style.display = 'block';
      }
      if (typeof global.FS === 'object' && typeof global.FS.setUserVars === 'function') {
        global.FS.setUserVars({ isCardFormNewMobile_bool: true });
      }

      // lets replace footer with new one
      const newFormFooter = document.querySelector('.jsNewFormFooter');
      if (formFooter && newFormFooter) {
        formFooter.parentElement.removeChild(formFooter);
      }
      newCardFormMobile = '1';
    } else if (formFooter && formFooter.childNodes && formFooter.childNodes[0]) {
      const footerButton = document.querySelector('.formFooter-button');
      const footerLogo = document.querySelector('.formFooter-logoLink');
      if (footerButton && footerLogo) {
        footerButton.href = `${footerButton.getAttribute('href')}_mobile`;
        footerLogo.href = `${footerLogo.getAttribute('href')}_mobile`;
      }
    }

    const input = createInput({ type: 'hidden', name: 'newCardFormMobile', value: newCardFormMobile });
    const form = document.querySelector('.jotform-form');
    if (form && input) {
      form.appendChild(input);
    }
  }

  // returns a random and time based unique submitter id for using in analytics
  createUniqueSubmitterID(formID) {
    return `${formID}_${Date.now()}_${Math.floor(Math.random() * 1000)}`;
  }

  initializeHWFeedbackEmbedButton() {
    addClass(document.body, 'forMiniCard');
    const input = createInput({ type: 'hidden', name: 'feedbackEmbedButton', value: '' });
    const form = document.querySelector('.jotform-form');
    if (form && input) {
      form.appendChild(input);
    }
    this.hwFeedbackEmbed.setDeviceType(getDeviceType());
    this.hwFeedbackEmbed.setOS(this.layoutParams.osName);
  }

  getCurrentCard() {
    const { currentCardIndex } = this.layoutParams;
    return this.cards[currentCardIndex];
  }

  /**
   * @description
   * This will find all focusable element descendents inside a card element.
   * ex: buttons, inputs, text-areas, iframes, anything with a tab-index
   * and set the tab-index to either 0 or -1.
   * @param {Object} props
   * @param {HTMLElement} props.card
   * @param {0 | -1} props.tabIndex
   */
  setCardTabIndex({ card, tabIndex }) {
    const container = card?.wrapperContainer;
    if (!container || !(container instanceof HTMLElement)) return;
    if (tabIndex !== 0 || tabIndex !== -1) return;

    const focusableElements = getElementsByFocus({
      target: container,

      // This will filter / ignore focusable elements inside the target if they match the specified attribute.
      // If we are setting the tab-index to 0, we want to exclude all elements that have a aria-hidden attribute.
      excludeAttributes: tabIndex === 0 ? 'aria-hidden' : '',

      // This will filter / ignore focusable elements inside the target if they have a specific style.
      // If we are setting the tab-index to 0, we want to ignore elements that are currently hidden.
      excludeStyles: tabIndex === 0 ? { opacity: '0', display: 'none' } : {}
    });
    focusableElements?.forEach(element => element.setAttribute('tabIndex', tabIndex));
  }

  // Check question and attach necessary classes
  attachComponentClassToCard(card) {
    // add componentClass for additional needs
    let componentClass;
    const { question } = card;
    switch (question.type) {
      case 'control_matrix':
        componentClass = new Matrix({
          question,
          isFeedbackEmbedButton: this.isFeedbackEmbedButton,
          selectNextQuestion: this.selectNextQuestion
        });
        break;
      case 'control_email':
        componentClass = new Email({
          question,
          cardContainer: card.cardContainer,
          showTooltip: this.showInputTooltip,
          removeTooltip: this.removeInputTooltip,
          formID: this.formID
        });
        break;
      case 'control_emojislider':
        componentClass = new EmojiSlider({
          question,
          cardContainer: card.cardContainer
        });
        break;
      default:
        break;
    }
    if (componentClass) {
      question.componentClass = componentClass; // eslint-disable-line
    }
  }

  checkFeedbackEmbedMode() {
    return global.location.href.indexOf('?feedbackEmbed=1') > -1 || (window.parent && !!window.parent.JotformFeedbackManager);
  }

  initializeFeedbackEmbedMode() {
    addClass(document.body, 'feedbackEmbedMode');
  }

  checkCardsIfFilled(cards) {
    cards.forEach(p => {
      if (NonInputFields.indexOf(p.question.type) === -1 && ['paymentType', 'products'].indexOf(p.type) === -1) this.updateCardStatus(p, false, true);

      const inputs = map(p.cardContainer.querySelectorAll('input.jfInput-input, jfInput-textarea, select.form-dropdown'), q => q);
      if (p.question.type !== 'control_datetime') {
        // datetime will keep its isFilled prop since chrome puts placeholders to it
        // set isFilled class to other inputs if they have value initially
        inputs.forEach(this.setFieldIsFilledIfHasValue);
      }
    });
  }

  bindMobileValidations() {
    const handleMobileInput = (() => {
      const currentCard = this.cards[this.layoutParams.currentCardIndex];
      if (this.erroredCards.indexOf(currentCard) !== -1) {
        this.validateCard(currentCard, false);
      }
    });
    global.document.body.addEventListener('input', handleMobileInput);
  }

  handleKeyboardTabs(e) {
    const { deviceType, currentCardIndex } = this.layoutParams;
    if (deviceType !== 'mobile') {
      if (currentCardIndex > -1 && this.cards[currentCardIndex].question.type === 'control_mixed') {
        if (e.type === 'blur' && e.target.validateInput) {
          e.target.validateInput();
        }
      }
      return;
    }
    const newTarget = e.type === 'blur' ? e.relatedTarget : e.target;
    const newField = closest(newTarget, '.jfCard');
    const newCardIndex = this.cards.findIndex(p => p.cardContainer === newField);
    if (currentCardIndex + 1 === newCardIndex) this.selectNextQuestion(true, true);
    if (currentCardIndex - 1 === newCardIndex) this.selectPreviousQuestion(true);
  }

  handleFullScreenToggle() {
    const isMobile = this.layoutParams.deviceType === 'mobile';
    if (isMobile) { return; }

    this.cards.forEach(card => {
      const skipCardTypes = ['control_textarea'];
      const questionType = card.question.type;
      const fullScreenBtn = card.cardContainer.querySelector('.jfQuestion-fullscreen');
      const calculationTreshold = 6;
      if (!fullScreenBtn) { return; }

      if (skipCardTypes.indexOf(questionType) === -1) {
        const containerHeight = card.questionContainer.clientHeight;
        if (!Number.isNaN(containerHeight)) {
          const { questionContainer: { scrollHeight } } = card;

          if ((containerHeight + calculationTreshold) < scrollHeight) {
            removeClass(fullScreenBtn, 'isHidden');
            fullScreenBtn.removeAttribute('aria-hidden');
            fullScreenBtn.setAttribute('tabindex', '0');
          } else {
            addClass(fullScreenBtn, 'isHidden');
            fullScreenBtn.setAttribute('aria-hidden', 'true');
            fullScreenBtn.setAttribute('tabindex', '-1');
          }
        }
      }
    });
  }

  toggleFullScreenMode() {
    const { currentCardIndex } = this.layoutParams;
    const currentCard = this.cards[currentCardIndex];
    const cardContainer = currentCardIndex > -1 ? currentCard.cardContainer : null;
    if (!cardContainer) { return; }

    const { fullScreenProxy } = this.layoutElements;
    const cardToolbar = currentCardIndex > -1 ? currentCard.cardToolbar : null;
    const cardActions = cardContainer.querySelector('.jfCard-actions');
    const cardActionNotifications = cardContainer.querySelector('.jfCard-actionsNotification');

    if (hasClass(document.body, 'isFullScreen')) {
      removeClass(document.body, 'isFullScreen');
      this.layoutParams.isFullScreenMode = false;
    } else {
      addClass(document.body, 'isFullScreen');
      this.layoutParams.isFullScreenMode = true;
    }

    if (this.layoutParams.isFullScreenMode) {
      const cardQuestion = cardContainer.querySelector('.jfCard-question');
      const errorMessage = cardContainer.querySelector('.form-error-message');

      if (cardQuestion) {
        const cardQuestionShadow = cardQuestion.cloneNode(true);
        const questionType = currentCard.question && currentCard.question.type ? currentCard.question.type : '';
        addClass(cardQuestionShadow, 'isShadow');
        fullScreenProxy.appendChild(cardQuestion);
        fullScreenProxy.setAttribute('data-type', questionType);
        cardContainer.insertBefore(cardQuestionShadow, cardActions);

        if (cardToolbar) {
          const cardToolbarShadow = cardToolbar.cloneNode(true);
          addClass(cardToolbarShadow, 'isShadow');
          addClass(fullScreenProxy, 'hasToolbar');
          cardContainer.insertBefore(cardToolbarShadow, cardActions);
          fullScreenProxy.appendChild(cardToolbar);
        }

        if (errorMessage) {
          addClass(fullScreenProxy, 'hasError');
          fullScreenProxy.appendChild(errorMessage);
        }

        this.applyFullScreenModeUI();
      }
    } else {
      const cardQuestion = fullScreenProxy.querySelector('.jfCard-question');
      const errorMessage = fullScreenProxy.querySelector('.form-error-message');

      if (cardQuestion) {
        this.layoutParams.isFullScreenMode = false;
        removeClass(fullScreenProxy, 'hasToolbar');
        fullScreenProxy.removeAttribute('data-type');

        cardContainer.querySelector('.jfCard-question.isShadow').remove();
        cardContainer.insertBefore(cardQuestion, cardActions);

        if (errorMessage) {
          cardActionNotifications.appendChild(errorMessage);
        }

        if (cardToolbar) {
          removeClass(fullScreenProxy, 'hasError');
          cardContainer.insertBefore(cardToolbar, cardActions);
          cardContainer.querySelector('.jfToolbar.isShadow').remove();
        }

        this.applyFullScreenModeUI();
      }
    }

    setTimeout(this.updateMatrixLayout, 450);
  }

  toggleFullScreenDisplayMode() {
    const { fullScreenProxy } = this.layoutElements;

    if (hasClass(fullScreenProxy, 'isNightMode')) {
      removeClass(fullScreenProxy, 'isNightMode');
    } else {
      addClass(fullScreenProxy, 'isNightMode');
    }
  }

  applyFullScreenModeUI() {
    const { currentCardIndex, isFullScreenMode } = this.layoutParams;
    const currentCard = this.cards[currentCardIndex];
    const questionType = currentCard.question.type;
    const { fullScreenProxy } = this.layoutElements;
    const cardContainer = currentCardIndex > -1 ? currentCard.cardContainer : null;
    const cardToolbar = currentCardIndex > -1 ? currentCard.cardToolbar : null;
    if (!cardContainer) { return; }

    switch (questionType) {
      case 'control_textarea':
        const textareaLimitSpan = fullScreenProxy.querySelector('.jfTextarea-infoSpan');
        const modeSwitch = fullScreenProxy.querySelector('.jfTextarea-modeSpan');

        if (isFullScreenMode) {
          if (textareaLimitSpan) {
            fullScreenProxy.appendChild(textareaLimitSpan);
          }

          if (modeSwitch) {
            modeSwitch.addEventListener('click', this.toggleFullScreenDisplayMode);
          }
        } else if (textareaLimitSpan && cardToolbar) {
          cardToolbar.appendChild(textareaLimitSpan);
          removeClass(fullScreenProxy, 'isNightMode');
        }
        break;
      default:
        break;
    }
  }

  bindFullScreenMode() {
    this.cards.forEach(({ cardContainer }) => {
      const fullScreenBtn = cardContainer.querySelector('.jfQuestion-fullscreen');
      if (fullScreenBtn) {
        fullScreenBtn.addEventListener('click', () => {
          this.toggleFullScreenMode();
        });
      }
    });
  }

  bindInputFocus() {
    const inputs = global.document.querySelectorAll('input, textarea, select');
    let focusedElement = null;
    const checkFocus = () => {
      if (this.layoutParams.hasTouch) {
        if (focusedElement) {
          addClass(document.body, 'isTouchKeyboardOpen');
        } else {
          removeClass(document.body, 'isTouchKeyboardOpen');
        }
      }
    };

    forEach(inputs, input => {
      if (input.type !== 'radio' && input.type !== 'checkbox') {
        input.addEventListener('focus', e => {
          this.handleKeyboardTabs(e);
          focusedElement = e.target;
          checkFocus();
        });

        input.addEventListener('blur', e => {
          e.preventDefault();
          this.handleKeyboardTabs(e);
          if (focusedElement === e.target) {
            focusedElement = null;
            checkFocus();
          }
        });
      }
    });
  }

  bindStartButton() {
    if (this.layoutElements.startButton) {
      const isWelcome = this.layoutParams.formMode === 'welcome';
      this.layoutElements.startButton.addEventListener('click', () => {
        const cardformWelcome = document.querySelector('#cardform-welcome-icon');
        const cardformHeader = document.querySelector('#cardform-header-icon');

        if (cardformWelcome && cardformHeader) {
          const child = cardformWelcome.firstChild;
          if (child && child.nodeName === 'DIV') {
            cardformHeader.innerHTML = child.innerHTML;
          } else {
            cardformHeader.innerHTML = cardformWelcome.innerHTML;
          }
        }

        this.setFormMode('form');
        this.hideWelcomeBadges();
        if (isWelcome) {
          this.shortenHeaders();
          this.calculateWelcomeSize();
          // this.fixLogoHeight();
          // this.calculateCardsHeight();
        }
        if (global.JotForm.nextPage) {
          this.selectNextQuestion();
        }
      });

      if (this.layoutElements.previousButton) {
        this.layoutElements.previousButton.addEventListener('click', () => {
          this.setFormMode('form');
          this.selectPreviousQuestion();
        });
      }
    }
  }

  onSubmit() {
    // check all cards for error after a delay then show form error message if it does not shown
    setTimeout(() => {
      if (this.cards.find(p => p.hasError && !p.isHidden)) {
        global.JotForm.showButtonMessage();
      }

      // for new mobile layout
      if (this.layoutParams.deviceType === 'mobile') {
        const submitError = document.querySelector('#jsSubmitError');
        const erroredFieldCount = this.cards.reduce((acc, card) => {
          return card.hasError ? acc + 1 : acc;
        }, 0);
        if (erroredFieldCount) {
          addClass(submitError, 'isVisible');
          submitError.innerHTML = `${erroredFieldCount} incomplete field${erroredFieldCount === 1 ? '' : 's'}.`;
          addClass(this.layoutElements.progressWrapper, 'hasSubmitError');
          this.onFormOverviewClicked(null, true);
          if (this.layoutParams.formMode === 'review') {
            this.setFormMode('form');
          }
        }
      }
    }, 50);
  }

  validateCard(_card, blurBefore = true, dontShowMessage = false) {
    const card = _card;

    if (card.type === 'creditCard' && card.question.type === 'control_square') {
      global.JotForm.squarePayment.validateFields();
    }

    // blur all form fields before validating. Some fields like control_datetime may its own validation logic when inputs lost focus.
    if (blurBefore) {
      forEach(card.cardContainer.querySelectorAll('input, textarea, select'), p => p.blur());
    }

    // this block for cardform square apm submitting failure
    // It checks selected pm and remove validation classes for the other apms' input(ach, creditcard etc.)
    const squareCc = card.type === 'creditCard' && card.question.type === 'control_square';
    const allSquarePaymentOptions = Array.from(document.querySelectorAll('input[name="radio-apm-cardform"]'));
    const selectedOpt = allSquarePaymentOptions.find(item => item.checked);
    const isSquareApmSelected = selectedOpt && selectedOpt.id;
    if (squareCc && selectedOpt) {
      const apmList = document.querySelectorAll('div[id="square-payment-method"]');
      Array.from(apmList).forEach(apm => {
        if (apm.dataset.id !== isSquareApmSelected) {
          const hasValidateClass = apm.querySelectorAll('input[type="text"]');
          if (hasValidateClass.length > 0) {
            Array.from(hasValidateClass).forEach(c => {
              c.classList.remove('form-validation-error', 'validate[required]');
            });
          }
        }
      });
    }

    const fieldsToCheck = card.cardContainer.querySelectorAll('*[class*="validate"]');
    const widgetsToCheck = card.cardContainer.querySelectorAll('*[class*="widget-required"]');

    let isValid = true;
    forEach(fieldsToCheck, field => {
      if (field.validateInput) {
        // const valid = field.validateInput();
        // if (!valid) isValid = false;
        isValid = field.validateInput(false, dontShowMessage) && isValid;
      }
    });

    if (card.type === 'creditCard' && card.question.type === 'control_braintree') {
      // Shopping Bag is not initializing in donation forms so we need to separate shopping bag condition
      const shoppingBagCondition = global.JotForm.shoppingBag ? global.JotForm.shoppingBag.getTotalSelectedItems() > 0 : true;
      if (shoppingBagCondition && global.JotForm.paymentTotal > 0) {
        isValid = global.JotForm.braintree.validateFields();
      }
    }

    if (card.type === 'creditCard' && card.question.type === 'control_stripe' && global.JotForm.stripe && typeof global.JotForm.stripe.validateStripe !== 'undefined') {
      // Shopping Bag is not initializing in donation forms so we need to separate shopping bag condition
      const shoppingBagCondition = global.JotForm.shoppingBag ? global.JotForm.shoppingBag.getTotalSelectedItems() > 0 : true;
      if (shoppingBagCondition && global.JotForm.paymentTotal > 0) {
        isValid = global.JotForm.stripe.validateStripe();
      }
    }
    if (global.CardForm !== undefined && global.JotForm !== undefined && card.cardContainer.hasAttribute('data-payment') && global.JotForm.isPaymentSelected()) {
      if (global.JotForm.hasMinTotalOrderAmount()) {
        card.hasError = global.JotForm.handleMinTotalOrderAmount();
      }
      if (card.type === 'creditCard' && card.question.type === 'control_mollie' && typeof global.__mollie !== 'undefined') {
        card.hasError = !global.__mollie.cardFormMollieValidate();
      }
    }

    if (card.type === 'products' && typeof global.PaymentStock !== 'undefined') {
      isValid = !card.hasError && global.PaymentStock.validations.validateStock();
    }

    let isWidgetRequired = false;
    if (widgetsToCheck.length) {
      isValid = widgetsToCheck[0].value.length === 0 ? false : true;
      if (!isValid && !card.isHidden) {
        isWidgetRequired = true;
      }
    } else if (card.question.type === 'control_fileupload') {
      isValid = fieldsToCheck.length ? card.cardContainer.querySelector('.jfUpload-files-container').validateInput() : true;
    } else if (card.question.type === 'control_address') {
      const addressContainer = card.cardContainer.querySelector('.jfAddress-clean');
      const autocompleteField = document.getElementById(`input_${card.question.id}_addr_search`);
      if (addressContainer && autocompleteField && autocompleteField.value) {
        addressContainer.classList.remove('jfAddress-clean');
      }
    } else {
      isValid = !card.hasError && isValid;
    }

    card.hasError = !isValid;

    // after a card is validated check for the form error and hide it if there is no card with error
    setTimeout(() => {
      if (!this.cards.find(p => p.hasError)) {
        global.JotForm.hideButtonMessage();
      }
    }, 50);

    const cardIndex = this.erroredCards.indexOf(card);
    if (!isValid && cardIndex !== -1) {
      this.erroredCards.splice(cardIndex, 1);
    }

    if (!isValid && isWidgetRequired) {
      global.JotForm.errored(widgetsToCheck[0], global.JotForm.texts.required || FORM_TEXTS.required);
    }

    return isValid;
  }

  isCardFilled(_card) {
    const card = _card;

    if (card.question.type === 'control_fileupload') {
      return this.onFileUploadChanged(card.question.id);
    }

    let fieldsToCheck = Array.prototype.slice.call(card.cardContainer.querySelectorAll('input, textarea, select'));
    const questionType = card.question.type;

    fieldsToCheck = fieldsToCheck.filter(field => {
      if (questionType === 'control_time') {
        if (field.match('[name*="ampm"]')) {
          return false;
        }
      }

      if (questionType === 'control_address') {
        if (field.match('[name*="dropdown_search"]') || field.match('[name*="country"]')) {
          return false;
        }
      }

      if (questionType === 'control_captcha') {
        if (field.match('[name="recaptcha_visible"]')) {
          return false;
        }
      }

      if (questionType === 'control_datetime') {
        if (field.match('[name*="ampm"]') || field.match('[name*="hour"]') || field.match('[name*="min"]')) {
          return false;
        }
      }

      if (questionType === 'control_appointment') {
        if (!field.match('[name*="date"]')) {
          return false;
        }
      }

      return true;
    });

    for (let i = 0; i < fieldsToCheck.length; i++) {
      const field = fieldsToCheck[i];

      // ignore widget settings input
      if (field.className.indexOf('form-widget-settings') > -1) continue;

      if (field.type === 'radio' || field.type === 'checkbox') {
        if (field.checked) {
          card.isFilled = true;
          return true;
        }
      } else if (field.value) {
        card.isFilled = true;
        return true;
      } else if (questionType === 'control_widget') {
        const widgetFrame = card.wrapperContainer && card.wrapperContainer.querySelector(`#customFieldFrame_${card.question.id}`);
        const isWidgetFilled = widgetFrame && widgetFrame.getAttribute('data-value') ? true : false;
        card.isFilled = isWidgetFilled;
        return isWidgetFilled;
      }
    }
    card.isFilled = false;
    return false;
  }

  onFieldCorrected(input) {
    // for new mobile layout
    if (this.layoutParams.deviceType === 'mobile') {
      const erroredFieldCount = this.cards.reduce((acc, card) => {
        return card.hasError ? acc + 1 : acc;
      }, 0);
      const submitErr = document.querySelector('#jsSubmitError');
      if (erroredFieldCount && submitErr.innerHTML !== '' && hasClass(submitErr, 'isVisible')) {
        submitErr.innerHTML = `${erroredFieldCount} incomplete field${erroredFieldCount === 1 ? '' : 's'}.`;
        addClass(this.layoutElements.progressWrapper, 'hasSubmitError');
      } else {
        removeClass(this.layoutElements.progressWrapper, 'hasSubmitError');
        removeClass(submitErr, 'isVisible');
      }
    }
    const line = global.JotForm.getContainer(input);
    const card = this.layoutParams.isFullScreenMode
      ? this.cards[this.layoutParams.currentCardIndex]
      : this.cards.find(p => p.cardContainer === line || p.cardContainer.contains(line));
    card.hasError = false;

    this.updateCardStatus(card, false, false);
    if (hasClass(input, 'form-dropdown')) {
      this.updateDropdown(input, false);
    }

    // clearing separately marked errors from mixed control.
    if (line.getAttribute('data-type') === 'control_mixed') {
      addClass(input.parentNode, 'isValid');
      removeClass(input.parentNode, 'hasError');
    }
  }

  onFieldErrored(input) {
    const line = global.JotForm.getContainer(input);

    // Select card basedfon the view mode
    const card = this.layoutParams.isFullScreenMode
      ? this.cards[this.layoutParams.currentCardIndex]
      : this.cards.find(p => p.cardContainer === line);

    if (this.layoutParams.isFullScreenMode) {
      addClass(card, 'hasError');
    }

    card.hasError = true;
    if (this.erroredCards.indexOf(card) === -1) {
      this.erroredCards.push(card);
    }
    this.updateCardStatus(card, false, false);
    if (hasClass(input, 'form-dropdown')) {
      this.updateDropdown(input, true);
    }

    // marking errored fields separately for mixed control.
    if (line.getAttribute('data-type') === 'control_mixed') {
      removeClass(input.parentNode, 'isValid');
      addClass(input.parentNode, 'hasError');
    }
  }

  updateDropdown(input, errored) {
    const field = closest(input, '.jfField');
    const customSelect = field.querySelector('.jfInput-dropdown');
    if (errored) {
      addClass(customSelect, 'form-validation-error');
    } else {
      removeClass(customSelect, 'form-validation-error');
    }
  }

  recalculateTransform() {
    // if (this.layoutParams.forTemplate) return;

    const { cardAnimationWrapper } = this.layoutElements;
    const {
      leftMargin,
      currentCardSize,
      scaleFactor,
      cardScrollScale,
      scrollLeftExtra,
      formMode,
      cardMode,
      resolutionType,
      globalCardScaleFactor
    } = this.layoutParams;

    const scaleValue = ((cardMode === 'scroll' && resolutionType !== 'mobile' ? cardScrollScale : 1) * scaleFactor) * globalCardScaleFactor;
    const currentScrollLeft = this.getScrollLeft() + scrollLeftExtra;

    const transformOriginX = leftMargin + currentScrollLeft + (currentCardSize / 2);
    const percent = formMode === 'welcome' ? ' 62%' : ' 50%';
    const transformOrigin = `${transformOriginX}px ${percent} 0`;

    const transform = `translate3d(-${currentScrollLeft}px, 0,0) scale3d(${scaleValue * scaleFactor}, ${scaleValue * scaleFactor},1)`;
    cardAnimationWrapper.style.transform = transform;
    cardAnimationWrapper.style.webkitTransform = transform;
    cardAnimationWrapper.style.MozTransform = transform;
    cardAnimationWrapper.style.msTransform = transform;

    cardAnimationWrapper.style.transformOrigin = transformOrigin;
    cardAnimationWrapper.style.webkitTransformOrigin = transformOrigin;
    cardAnimationWrapper.style.MozTransformOrigin = transformOrigin;
    cardAnimationWrapper.style.msTransformOrigin = transformOrigin;
  }

  onFormOverviewClicked(event, scrollToFirstError) {
    const isMobile = this.layoutParams.deviceType === 'mobile';
    if (this.layoutParams.cardMode === 'scroll') {
      if (!this.progress.isFormProgressVisible && !isMobile && this.progress.layoutElements.progressItemsLine && this.progress.layoutElements.progressItemWrapper) {
        addClass(this.progress.layoutElements.progressItemsLine, ' jfProgress-hiddenWrapper');
        addClass(this.progress.layoutElements.progressItemWrapper, ' jfProgress-hiddenWrapper');
      }

      this.setCardIndex(this.getNearestCardIndexInScrollMode());
      this.setCardMode('single');
    } else {
      this.setCardMode('scroll', true);
      if (isMobile) {
        if (scrollToFirstError) {
          const firstErroredProgress = document.querySelector('.jfProgress-item.hasError');
          if (firstErroredProgress) {
            const { x } = firstErroredProgress.getBoundingClientRect();
            const progressWrapper = document.querySelector('.jfProgress#cardProgress');
            progressWrapper.scrollTop = x;
          }
        }
      } else {
        if (!this.progress.isFormProgressVisible && this.progress.layoutElements.progressItemsLine && this.progress.layoutElements.progressItemWrapper) {
          removeClass(this.progress.layoutElements.progressItemsLine, 'jfProgress-hiddenWrapper');
          removeClass(this.progress.layoutElements.progressItemWrapper, 'jfProgress-hiddenWrapper');
        }
        this.recalculateSmartEmbedLayout();
      }
    }
  }

  handleFeedbackButtonProgress() {
    if (!this.isFeedbackEmbedButton) return;
    const visibleQuestions = this.cards.filter(p => !p.isHidden);
    if (visibleQuestions.length) {
      const currentCardIndex = this.layoutParams.currentCardIndex || 1;
      const currentCard = this.cards[currentCardIndex];
      const currentQuestionIndex = visibleQuestions.indexOf(currentCard) + 1;
      const feedbackProgress = document.querySelector('.jsFeedbackProgressLine');
      const percentage = Math.ceil((currentQuestionIndex / visibleQuestions.length) * 100);
      feedbackProgress.style.width = `${percentage}%`;
    }
  }

  onProgressItemSelected(index) {
    if (this.layoutParams.resolutionType === 'mobile') {
      this.removeLayoutAnimation();
      this.setCardIndex(index, true);
      this.setCardMode('single', true);
      this.addLayoutAnimation(10);
      return;
    }

    if (this.layoutParams.cardMode === 'scroll') {
      this.setCardIndex(index);
      this.removeLayoutAnimation(400); // remove transition animation after form moved to selected card index
    } else {
      this.selectQuestion(index);
    }
  }

  arrangeSectionHeaders(welcomProps, sectionHeaders) {
    this.sectionHeaders = sectionHeaders;

    this.sectionHeaders.forEach(_header => {
      const header = _header;
      if (header.props.hidden && header.props.hidden.value === 'Yes') {
        header.isHidden = true;
      }
    });

    this.welcomePageProps = {
      index: 0,
      props: welcomProps || {}
    };

    if (!this.welcomePageProps.props.text) this.welcomePageProps.props.text = {};
    if (!this.welcomePageProps.props.subHeader) this.welcomePageProps.props.subHeader = {};
  }

  getSectionHeaderForIndex(_index) {
    const index = Object.keys(this.paymentsMergedCards).findIndex(e => e === this.cards[_index].question.qid);
    if (!this.layoutParams.formMode || this.layoutParams.formMode === 'welcome') {
      return this.welcomePageProps;
    }

    let currentHeader;
    if (this.sectionHeaders && this.sectionHeaders.length) {
      for (let i = this.sectionHeaders.length - 1; i >= 0; i--) {
        const header = this.sectionHeaders[i];
        if (header.index <= index) {
          currentHeader = header;
          break;
        }
      }
    }

    if (!currentHeader) {
      currentHeader = this.welcomePageProps;
    }

    return currentHeader;
  }

  updateFormHeader(sectionHeader) {
    if (this.sectionHeaders && sectionHeader && this.sectionHeaders.length && this.currentHeader !== sectionHeader) {
      const header = sectionHeader.props.text ? sectionHeader.props.text.value : undefined;
      const subHeader = sectionHeader.props.subHeader ? sectionHeader.props.subHeader.value : undefined;
      // section info
      const showSectionInfo = (sectionHeader.props.showQuestionCount && sectionHeader.props.showQuestionCount.value === 'Yes') ? true : false;
      let sectionQuestionCount = '';

      let nextButtonText;
      let previousButtonText;

      if (sectionHeader === this.welcomePageProps) {
        nextButtonText = this.welcomePageProps.props.buttonText ? this.welcomePageProps.props.buttonText.value : 'Start';

        document.querySelector('.jfWelcome-wrapper')?.classList.remove('isHeader');
        this.layoutElements.previousButton?.classList.remove('jfInput-button', 'forPrev-heading');
        this.layoutElements.startButton?.classList.remove('jfInput-button', 'forNext-heading');
        // previousButtonText = this.welcomePageProps.props.buttonText ? this.welcomePageProps.props.buttonText.value : 'Start';
      } else {
        const actionNextText = this.cards[0] ? this.cards[0].actionsButtons.next.innerHTML : 'Next';
        const actionPreviousText = this.cards[0] ? this.cards[0].actionsButtons.prev.innerHTML : 'Previous';
        nextButtonText = sectionHeader.props.nextButtonText && sectionHeader.props.nextButtonText.value ? sectionHeader.props.nextButtonText.value : actionNextText;
        previousButtonText = sectionHeader.props.previousButtonText && sectionHeader.props.previousButtonText.value ? sectionHeader.props.previousButtonText.value : actionPreviousText;
        document.querySelector('.jfWelcome-wrapper')?.classList.add('isHeader');
        this.layoutElements.previousButton?.classList.add('jfInput-button', 'forPrev-heading');
        this.layoutElements.startButton?.classList.add('jfInput-button', 'forNext-heading');
      }

      if (header !== undefined) {
        this.layoutElements.welcomeHeaderContainer.innerHTML = DomPurify.sanitize(header);
      } else {
        this.layoutElements.welcomeHeaderContainer.innerHTML = DomPurify.sanitize(this.welcomePageProps.props.text.value);
      }

      if (subHeader !== undefined) {
        this.layoutElements.welcomeSubHeaderContainer.innerHTML = DomPurify.sanitize(subHeader);
      } else {
        this.layoutElements.welcomeSubHeaderContainer.innerHTML = DomPurify.sanitize(this.welcomePageProps.props.subHeader.value || '');
      }

      const { allQuestions } = this.layoutParams;
      const { welcomeSectionInfoQuestionCount, welcomeSectionInfoText } = this.layoutElements;

      if (showSectionInfo && sectionHeader.props.id.value !== 'welcomePage') {
        const headIndex = this.sectionHeaders.map(q => { return q.props.id.value; }).indexOf(sectionHeader.props.id.value);
        const currentHeaderID = sectionHeader.props.id.value.toString();
        const nextHeaderID = this.sectionHeaders[headIndex + 1] ? this.sectionHeaders[headIndex + 1].props.id.value.toString() : false;

        const list = allQuestions.map(q => { return q.id; });

        const currentHeaderIndex = list.indexOf(currentHeaderID);
        if (currentHeaderIndex !== -1) {
          const nextHeaderIndex = nextHeaderID ? list.indexOf(nextHeaderID) : false;

          const sectionQuestions = nextHeaderIndex ? allQuestions.slice(currentHeaderIndex + 1, nextHeaderIndex) : allQuestions.slice(currentHeaderIndex + 1);
          const visibleSectionQuestions = sectionQuestions.map(q => {
            return this.cards.find(p => p.question.id === q.id);
          });
          sectionQuestionCount = visibleSectionQuestions.filter(p => !p.isHidden).length;
        }
        welcomeSectionInfoText.innerHTML = parseInt(sectionQuestionCount, 10) > 1 ? 'Questions'.locale() : 'Question'.locale();
      } else if (showSectionInfo && sectionHeader.props.id.value === 'welcomePage') {
        sectionQuestionCount = this.cards.filter(p => !p.isHidden && p.question.type !== 'control_head').length;
      }
      welcomeSectionInfoQuestionCount.innerHTML = sectionQuestionCount;

      this.layoutElements.startButton.innerHTML = nextButtonText;

      if (this.layoutElements.previousButton) {
        this.layoutElements.previousButton.innerHTML = previousButtonText;
        if (sectionHeader.index === 0) {
          this.layoutElements.previousButton.style.display = 'none';
          addClass(document.querySelector('.jfWelcome-wrapper'), 'noPrevButton');
        } else {
          this.layoutElements.previousButton.style.display = 'inline';
          this.layoutElements.previousButton.style.visibility = 'visible';
          this.layoutElements.previousButton.ariaHidden = 'false';
          this.layoutElements.welcomeHeaderContainer.style.opacity = '1';
          removeClass(document.querySelector('.jfWelcome-wrapper'), 'noPrevButton');
        }
      }
    }
    this.currentHeader = sectionHeader;
    this.checkHeaderSubHeaderCharLimits(sectionHeader);
    this.translateSectionHeader();
    if (this.layoutParams.formMode === 'form') this.shortenHeaders();

    if (this.layoutParams.formMode === 'sectionHeader') this.calculateWelcomeSize();
  }

  checkHeaderSubHeaderCharLimits(sectionHeader) {
    if (sectionHeader) {
      const header = sectionHeader.props.text ? sectionHeader.props.text.value : undefined;
      const subHeader = sectionHeader.props.subHeader ? sectionHeader.props.subHeader.value : undefined;

      if (this.layoutParams.resolutionType === 'mobile') {
        if (header && header.length > (this.layoutParams.formMode === 'welcome' ? 100 : 75)) {
          addClass(this.layoutElements.welcomeHeaderContainer, 'isLong');
        } else {
          removeClass(this.layoutElements.welcomeHeaderContainer, 'isLong');
        }

        if (subHeader && subHeader.length > (this.layoutParams.formMode === 'welcome' ? 100 : 75)) {
          addClass(this.layoutElements.welcomeSubHeaderContainer, 'isLong');
        } else {
          removeClass(this.layoutElements.welcomeSubHeaderContainer, 'isLong');
        }
      }
    }
  }

  setPrevNextQuestion(newIndex) {
    let nextIndex = newIndex + 1;
    let prevIndex = newIndex - 1;
    this.cards.forEach(card => {
      removeClass(card.wrapperContainer, 'prevQuestion');
      removeClass(card.wrapperContainer, 'nextQuestion');
      card.wrapperContainer.removeAttribute('aria-hidden');
    });
    while (nextIndex < this.cards.length && this.cards[nextIndex].isHidden) {
      nextIndex++;
    }
    if (nextIndex < this.cards.length) {
      addClass(this.cards[nextIndex].wrapperContainer, 'nextQuestion');
      this.cards[nextIndex].wrapperContainer.setAttribute('aria-hidden', 'true');
    }

    while (prevIndex > -1 && this.cards[prevIndex].isHidden) {
      prevIndex--;
    }
    if (prevIndex > -1) {
      addClass(this.cards[prevIndex].wrapperContainer, 'prevQuestion');
      this.cards[prevIndex].wrapperContainer.setAttribute('aria-hidden', 'true');
    }
  }

  setMobilePrevNextQuestionButtons(currentCardIndex) {
    if (this.layoutParams.deviceType !== 'mobile' && !this.isFeedbackEmbedButton) { return; }
    const {
      mobileNextButton,
      mobilePrevButton,
      mobileSubmitButton,
      mobileProgressInfo,
      progressWrapper,
      mobileUseJFSignButton
    } = this.layoutElements;
    const firstVisibleIndex = this.getFirstVisibleIndex();
    const lastVisibleIndex = this.getLastVisibleIndex();
    const backVisiblity = firstVisibleIndex !== currentCardIndex ? 'block' : 'none';
    const nextVisibility = lastVisibleIndex !== currentCardIndex ? 'block' : 'none';
    const submitVisibility = lastVisibleIndex === currentCardIndex ? 'inline-block' : 'none';
    const submitButton = (global.useJotformSign === 'Yes' && mobileUseJFSignButton && !this.layoutParams.reviewBeforeSubmit)
      ? mobileUseJFSignButton
      : mobileSubmitButton;

    if (mobileNextButton) { mobileNextButton.style.display = nextVisibility; }
    if (mobilePrevButton) { mobilePrevButton.style.display = backVisiblity; }
    if (submitButton) { submitButton.style.display = submitVisibility; }
    if (mobileProgressInfo) {
      if (lastVisibleIndex !== currentCardIndex) {
        mobileProgressInfo.style.display = 'block';
        addClass(progressWrapper, 'isProgressButtonVisible');
      } else {
        mobileProgressInfo.style.display = 'none';
        removeClass(progressWrapper, 'isProgressButtonVisible');
      }
    }
  }

  doObjectsCollide(DOMNode1, DOMNode2, checkTolerance = 0) {
    const getBoundsForNode = node => {
      const rect = node.getBoundingClientRect();

      return {
        top: rect.top + global.document.body.scrollTop,
        left: rect.left + global.document.body.scrollLeft,
        offsetWidth: node.offsetWidth,
        offsetHeight: node.offsetHeight
      };
    };

    const coordsCollide = (aTop, aLeft, bTop, bLeft, aWidth, aHeight, bWidth, bHeight, tolerance) => {
      const toleranceDistance = (typeof tolerance === 'undefined') ? 0 : tolerance;

      return !(
        (((aTop + aHeight) - toleranceDistance) < bTop)
          || ((aTop + toleranceDistance) > (bTop + bHeight))
          || (((aLeft + aWidth) - toleranceDistance) < bLeft)
          || ((aLeft + toleranceDistance) > (bLeft + bWidth))
      );
    };

    const checkCollision = (a, b, tolerance = 0) => {
      const aObj = (a instanceof global.HTMLElement) ? getBoundsForNode(a) : a;
      const bObj = (b instanceof global.HTMLElement) ? getBoundsForNode(b) : b;

      return coordsCollide(
        aObj.top,
        aObj.left,
        bObj.top,
        bObj.left,
        aObj.offsetWidth,
        aObj.offsetHeight,
        bObj.offsetWidth,
        bObj.offsetHeight,
        tolerance
      );
    };
    return checkCollision(DOMNode1, DOMNode2, checkTolerance);
  }

  updateFeedbackEmbedHeight() {
    if (!this.layoutParams.isFeedbackEmbedButton) { return; }
    const card = this.cards[this.layoutParams.currentCardIndex];
    // update this
    // const scrollThreshold = 10;
    const question = card.cardContainer.querySelector('.jfCard-question');
    const questionHeight = question.getBoundingClientRect().height;
    const scrollHeight = Math.abs(question.scrollHeight - questionHeight);
    const bottomBarHeight = 48;
    this.hwFeedbackEmbed.updateWindowHeight({
      messageType: 'updateHeight',
      questionHeight,
      scrollHeight,
      bottomBarHeight
    });
  }

  recalculateSmartEmbedLayout() {
    const {
      welcomeWrapper,
      progressWrapper,
      welcomeContainer,
      progressContainer,
      logoContainer
    } = this.layoutElements;
    const {
      smartEmbedMaxHeight,
      currentCardIndex,
      cardMode,
      formMode,
      resolutionType
    } = this.layoutParams;
    const cardContainer = currentCardIndex > -1 ? this.cards[currentCardIndex].cardContainer : null;
    const cardDimensions = cardContainer ? cardContainer.getBoundingClientRect() : { y: 100, height: 100 };
    const smartEmbedTreshold = smartEmbedMaxHeight + 200;
    const isSmartEmbed = hasClass(document.body, 'isSmartEmbed');
    const isMobile = resolutionType === 'mobile';

    if (cardContainer && logoContainer) {
      setTimeout(() => {
        if (this.doObjectsCollide(cardContainer, logoContainer, 15)) {
          addClass(logoContainer, 'isHidden');
        } else {
          removeClass(logoContainer, 'isHidden');
        }
      }, 300);
    }

    if (isSmartEmbed && this.layoutParams.isEmbed && this.jsForm) {
      const collisionTreshold = 120;
      const progressAdditionalMargin = 20;
      const welcomeContainerDimensions = welcomeContainer.getBoundingClientRect();
      const progressContainerDimensions = progressContainer.getBoundingClientRect();
      const requiredHeight = cardDimensions.height + collisionTreshold;

      if (cardMode === 'single' && formMode === 'form') {
        welcomeContainer.style.width = `${cardDimensions.width}px`;
      }
      if (cardMode === 'scroll' || formMode === 'welcome') {
        removeClass(document.body, 'isSmartEmbedCleanState');
        if (welcomeContainerDimensions.height) {
          welcomeWrapper.style.height = `${welcomeContainerDimensions.height}px`;
        }
        if (cardMode === 'scroll' && isMobile) {
          progressWrapper.style.height = null;
        } else {
          progressWrapper.style.height = `${progressContainerDimensions.height + progressAdditionalMargin}px`;
        }
      } else if (requiredHeight > smartEmbedTreshold) {
        addClass(document.body, 'isSmartEmbedCleanState');
        welcomeWrapper.style.height = `${welcomeContainerDimensions.height}px`;
        progressWrapper.style.height = `${progressContainerDimensions.height + progressAdditionalMargin}px`;
      } else {
        removeClass(document.body, 'isSmartEmbedCleanState');
        welcomeWrapper.style.height = `${cardDimensions.y}px`;
        progressWrapper.style.height = `${cardDimensions.y}px`;
      }
    } else {
      // Clearing embed styling
      welcomeWrapper.style.height = null;
      progressWrapper.style.height = null;
    }
  }

  handleFormSubmitError(newVisibleCard) {
    const submitButton = newVisibleCard.cardContainer.querySelector('.jfCard-actions .forSubmit');
    const cardActionNotifications = newVisibleCard.cardContainer.querySelector('.jfCard-actionsNotification');
    const errorMessage = cardActionNotifications.querySelector('.form-error-message');

    // find so far errored cards with their indexes
    const errorCards = this.cards.filter(p => !p.isHidden).reduce((acc, card, index) => {
      if (card.hasError) {
        acc.push({ card, index: index + 1 });
      }
      return acc;
    }, []);

    const errQCount = errorCards.length;
    if (!errQCount) {
      submitButton.removeAttribute('disabled');
      cardActionNotifications.removeChild(errorMessage);
      return;
    }

    let errorText = '';
    if (errQCount === 1) {
      errorText = `${errorCards[0].index}`;
    } else {
      const lastElementIndex = errorCards[errQCount - 1].index;
      const indexes = errorCards.map(a => a.index);
      if (errQCount <= 4) {
        indexes.pop();
        const othersText = indexes.join(', ');
        errorText = `${othersText} and ${lastElementIndex}`;
      } else {
        const othersText = indexes.splice(0, 3).join(', ');
        errorText = `${othersText} and ${errQCount - 3} other questions`;
      }
    }

    // handle errored fields text with index
    const newText = `Please answer the question ${errorText} before continuing.`;

    // show error text
    if (errorMessage) {
      errorMessage.innerHTML = newText;
    } else {
      const actionHTML = document.createElement('div');
      actionHTML.className = 'form-error-message';
      actionHTML.role = 'alert';
      actionHTML.innerHTML = newText;
      cardActionNotifications.appendChild(actionHTML);
    }
    submitButton.setAttribute('disabled', 'disabled');
    // go to first errored card with click
  }

  setCardIndex(index, withoutTransition, initial) {
    if (index === -1) {
      return;
    }
    if (this.cards[index].isHidden) {
      console.warn('trying to select a hidden question!!!'); // eslint-disable-line
    }
    const { currentCardIndex, formMode: currMode } = this.layoutParams;

    // check card if its filled to make progress item green. validation is done in selectNextQuestion
    if (currentCardIndex > -1) {
      this.updateCardStatus(this.cards[currentCardIndex], false, true);
    }

    const animationState = this.layoutParams.isLayoutAnimated;
    if (!withoutTransition) {
      this.addLayoutAnimation();
    } else {
      this.removeLayoutAnimation();
    }

    this.setPrevNextQuestion(index);
    if (currentCardIndex > -1) {
      const previousCard = this.cards[currentCardIndex];
      if (this.isAccessibleForm) {
        this.setCardTabIndex({ card: previousCard, tabIndex: -1 });
      }
      removeClass(previousCard.wrapperContainer, 'isVisible');
      // send the disable message to Iframe Embed widget in the previous card
      const { id, type } = previousCard.question;
      if (type === 'control_widget' && previousCard.wrapperContainer.querySelectorAll('[data-widget-id="5295629cba137d764f000004"]').length > 0) {
        global.JotForm.disableWidget(id);
      }
    }
    this.layoutParams.currentCardIndex = index;
    const newVisibleCard = this.cards[this.layoutParams.currentCardIndex];
    if (this.isAccessibleForm) {
      this.setCardTabIndex({ card: newVisibleCard, tabIndex: 0 });
    }

    addClass(newVisibleCard.wrapperContainer, 'isVisible');
    if (newVisibleCard.question.type === 'control_matrix') {
      // Because of layout calculations, matrix layout can be broken
      // Lets re-calculate it until we fix other calculations.
      setTimeout(() => {
        global.JotForm.setMatrixLayout(newVisibleCard.question.id);
      }, 10);
    }
    // if (newVisibleCard.hasSubmit) {
    //   this.handleFormSubmitError(newVisibleCard);
    // }

    // update welcome header status
    if (currMode !== 'welcome' && currMode !== null) {
      this.hideWelcomeBadges();
    }

    const hideWelcomeIndex = this.hasWelcome ? 0 : 1;
    if ((currMode === 'form' && index >= hideWelcomeIndex) || (currMode === 'form' && !this.welcomePageProps.props.isFormTitleVisible)) {
      this.hideHeader();
    } else {
      this.showHeader();
    }

    // update feedback button height
    if (!withoutTransition) {
      setTimeout(() => {
        this.updateFeedbackEmbedHeight();
      }, 300);
    } else {
      this.updateFeedbackEmbedHeight();
    }

    this.handleFeedbackButtonProgress();

    this.setMobilePrevNextQuestionButtons(index);
    // remove extra scroll margin of wheel or drag when selecting new card
    this.layoutParams.scrollLeftExtra = 0;
    this.progress.selectIndex(index);
    this.recalculateTransform();
    if (this.layoutParams.formMode === 'form' && !this.layoutParams.hasTouch) {
      this.focusToFirstInput(this.cards[index]);
    }

    // close all popups of dropdown and calendars
    this.datetimeHandler.closeAllCalendars();
    this.dropdown.closeAllDropdowns();
    if (animationState && withoutTransition) this.addLayoutAnimation(1);

    this.updateFormHeader(this.getSectionHeaderForIndex(index));
    if (!initial) {
      this.hiddenSubmit();
    }
    this.recalculateSmartEmbedLayout();
    // Update hash with current question number ~ disable for now.
    if (this.layoutParams.formMode === 'form') {
      // global.location.hash = `${index + 1}`;
    }

    if (this.pressEnterHint && this.layoutParams.formMode === 'form' && !this.canQuestionMoveAutomatically(this.getCurrentCard().question.question_type)) {
      this.pressEnterHint.show();
    }

    this.calculateAvailableHeightForFields(index);

    if (
      currMode === 'form'
      && global.FormTranslation
      && global.FormTranslation.properties
      && global.FormTranslation.properties.firstPageOnly === '1'
    ) {
      const firstVisibleCardIndex = this.cards.findIndex(card => card.isHidden === false);
      this.setLanguageDropdownVisibility(firstVisibleCardIndex, index);
    }

    // reshow widgets if possible
    this.handleWidgetsVisibility(newVisibleCard);
  }

  hiddenSubmit(forceSubmit) {
    // SACL: Save And Continue Later
    let sessionAndTokenBasedSACLActivated = false;
    let onlySessionBasedSACLActivated = false;

    if (this.isSaveAndContinueLaterActivated && this.saveAndContinueLater.inited && this.continueLater.active) {
      sessionAndTokenBasedSACLActivated = true;
    } else if (global.JotForm.sessionID) {
      onlySessionBasedSACLActivated = true;
    }

    if (!(sessionAndTokenBasedSACLActivated || onlySessionBasedSACLActivated)) {
      return false;
    }
    if (this.saveAndContinueLater && this.saveAndContinueLater.hiddenSubmit) {
      return this.saveAndContinueLater.hiddenSubmit();
    }
    const jotformForm = document.forms[0];
    const currentValues = this.getInputNamesAndValues();
    // get diff with previous session for atomic submission.
    const diff = this.getFormDataDiff(currentValues, this.continueLater.lastAnswers, jotformForm);
    if ((diff.length > 0 || !!forceSubmit) && !global.JotForm.loadingPendingSubmission) {
      this.continueLater.lastAnswers = currentValues;
      const merged = this.mergeDiffWithStaticData(diff);
      if (!merged) { return; }
      const dummyForm = jotformForm.cloneNode(false);
      document.body.appendChild(dummyForm);

      for (let i = 0; i < merged.length; i++) {
        const p = merged[i];
        const input = createInput({ type: 'hidden', name: p.name, value: p.value });
        dummyForm.appendChild(input);
      }

      global.JotForm.hiddenSubmit(dummyForm, {
        async: true,
        onSuccessCb: response => {
          // set the submissionId if it is not exist
          if (!global.JotForm.submissionID && response.responseText) {
            const resJSON = JSON.parse(response.responseText);
            global.JotForm.setSubmissionID(resJSON.submissionId);
          }
          // if file uploaded then run makeUploadCheck to update related fields
          const regexTempFile = /temp_upload\[.*?]\[.*?]$/g; // file upload input name format
          const shouldUploadCheck = diff.some(d => regexTempFile.test(d.name));
          if (shouldUploadCheck) {
            global.JotForm.makeUploadChecks();
          }
          if (this.saveAndContinueLater) {
            this.saveAndContinueLater.changeState(this.saveAndContinueLater.states.saved);
          }
        },
        onFailureCb: () => {
          this.saveAndContinueLater.changeState(this.saveAndContinueLater.states.error);
        },
        onCompleteCb: () => {
          document.body.removeChild(dummyForm);
        }
      });
    }
  }

  mergeDiffWithStaticData(diff) {
    const data = [];
    const simpleSpc = document.getElementById('simple_spc'); // Simple spam check
    data.push({ name: 'session_id', value: global.JotForm.sessionID });
    if (global.JotForm.submissionID) {
      data.push({ name: 'submission_id', value: global.JotForm.submissionID });
    }
    if (simpleSpc) {
      data.push({ name: 'simple_spc', value: simpleSpc.value });
    }
    // data.push({ name: 'continueLater', value: '1' });
    // data.push({ name: 'hidden_submission', value: '1' });
    data.push({ name: 'submission_token', value: global.JotForm.submissionToken });
    data.push({ name: 'formID', value: this.formID });
    data.push({ name: 'continue_card_index', value: this.layoutParams.currentCardIndex }); // where user might left off
    const merged = [...diff];
    for (let i = 0; i < data.length; i++) {
      const isExists = !!merged.find(q => q.name === data[i].name);
      if (!isExists) {
        merged.push(data[i]);
      }
    }
    return merged;
  }

  getFormDataDiff(currentData, previousData, jotformForm) {
    return currentData.filter(current => {
      // always send uploadedBefore fields
      if (current.name.include('uploadedBefore')) {
        return true;
      }
      // always send all array like inputs with values, otherwise it causes problem while merging on the server side (except file upload inputs)
      const regexOneDim = /\[.*?]$/g; // 1D array like inputs include '[*]' in their names
      const regexTempFile = /temp_upload\[.*?]\[.*?]$/g; // file upload input name format
      if (regexOneDim.test(current.name) && !regexTempFile.test(current.name)) {
        // if it is a two dimensional array input like 'control_matrix', always return all of them although it has no value. otherwise the order of inputs will be changed
        const regexTwoDim = /\[.*?]\[.*?]$/g; // 2D array like inputs include '[*][]' in their names
        if (current.name.match(regexTwoDim)) {
          return true;
        }
        // if it is an unselected other option, do not send it
        const checkboxOther = jotformForm.querySelector(`input[type="checkbox"][name="${current.name}"]`);
        if (current.name.include('[other]') && checkboxOther && !checkboxOther.checked) {
          return false;
        }
        return !!current.value;
      }
      // if there is no previous data, send it
      if (!previousData) {
        return true;
      }
      // send only changed values, if it is not an array like input
      return !previousData.find(prev => prev.name === current.name && prev.value === current.value);
    });
  }

  get visibleCards() {
    return this.cards.filter((card, index) => { return this.isVisibleIndex(index) ? card : false; });
  }

  get isAccessibleForm() {
    return global.JotForm.accessible ?? false;
  }

  get currentCard() {
    const { currentCardIndex } = this.layoutParams;
    if (typeof currentCardIndex !== 'number') return;
    return this.cards?.[currentCardIndex];
  }

  get isFeedbackEmbedButton() {
    return window.location.href.indexOf('?feedbackEmbedButton') !== -1;
  }

  get isAIAgentEmbed() {
    return new URLSearchParams(window.location.search).get('isAIAgentEmbed') === '1';
  }

  get isContinueLaterActivated() { // TODO Burak to remove?
    const isSessionIDExists = this.hiddenSubmissionSessionID ? true : false;
    return (isSessionIDExists ? !this.isEditMode() : false);
  }

  get hiddenSubmissionSessionID() {
    if (!global.JotForm.sessionID) {
      global.JotForm.sessionID = document.get.session;
    }
    return global.JotForm.sessionID;
  }

  get isPreviewMode() {
    return global.location && global.location.href.indexOf('preview=true') >= 0;
  }

  get isManualPrefillCreation() {
    return window.location.href.indexOf('jf_createPrefill=1') !== -1;
  }

  get isPrefilledForm() {
    var path = window.location.pathname.split('/').splice(2);
    return (typeof document.get.prefillToken !== 'undefined') || (path[0] === 'prefill' && path[1].split('?')[0].trim() !== '');
  }

  get isFullscreenFormEnabled() {
    let isEnabled = this.layoutParams.fullscreenForm && this.layoutParams.isEmbed;

    const isMobile = this.layoutParams.deviceType === 'mobile';
    const isFeedbackEmbed = this.isFeedbackEmbedButton;
    const { isPreviewMode, isManualPrefillCreation, isAIAgentEmbed } = this;
    const isEditMode = this.isEditMode();
    const isSingleCardNoWelcome = this.cards.length === 1 && this.layoutParams.formMode === 'form';

    if (isMobile || isFeedbackEmbed || isPreviewMode || isEditMode || isSingleCardNoWelcome || isManualPrefillCreation || isAIAgentEmbed) {
      isEnabled = false;
    }

    return isEnabled;
  }

  showInputTooltip(input, { message, callback, onClose }) {
    const questionWrapper = closest(input, '.jfQuestion-fields');
    const cardWrapper = closest(input, '.jfCard-wrapper');
    const [firstPart, actionPart, lastPart] = message.split('|');
    // const keenData = {
    //   formID: this.formID,
    //   currentValue: input.value,
    //   suggestionValue: actionPart
    // };

    // // keen event
    // const openData = Object.assign({}, keenData, { type: 'opened' });
    // collectKeenEvent('email_field_tooltip', openData);

    const tooltipContainer = questionWrapper ? questionWrapper.querySelector('.js-tooltipContainer') : false;
    if (!tooltipContainer) { return; }

    if (cardWrapper) {
      cardWrapper.addEventListener('click', e => {
        if (!closest(e.target, '.js-tooltipContainer')) {
          this.removeInputTooltip(input);
        }
      });
    }

    const tooltipMessageContainer = tooltipContainer.querySelector('.js-tooltipMessageContainer-info');
    const tooltipCloseButton = tooltipContainer.querySelector('.js-tooltipCloseButton');

    tooltipCloseButton.addEventListener('click', e => {
      e.preventDefault();
      // keen event
      // const closeData = Object.assign({}, keenData, { type: 'closed' });
      // collectKeenEvent('email_field_tooltip', closeData);
      this.removeInputTooltip(input);
      if (onClose) { onClose(); }
    });

    tooltipMessageContainer.innerHTML = '';

    const textNode = document.createTextNode(firstPart);
    tooltipMessageContainer.appendChild(textNode);

    if (actionPart) {
      // callback action
      const actionHTML = document.createElement('span');
      actionHTML.innerHTML = actionPart;
      actionHTML.className = 'jfCardTooltip-link';
      tooltipMessageContainer.appendChild(actionHTML);

      actionHTML.addEventListener('click', e => {
        if (callback) { callback(e); }
        this.removeInputTooltip(input);
        // keen event
        // const clickData = Object.assign({}, keenData, { type: 'clicked' });
        // collectKeenEvent('email_field_tooltip', clickData);
      });

      if (lastPart) {
        const lastNode = document.createTextNode(lastPart);
        tooltipMessageContainer.appendChild(lastNode);
      }
    }
    addClass(questionWrapper, 'isTooltipOpen');
  }

  removeInputTooltip(input) {
    const questionWrapper = closest(input, '.jfQuestion-fields');
    const tooltipContainer = questionWrapper ? questionWrapper.querySelector('.js-tooltipContainer') : false;
    if (tooltipContainer) {
      const tooltipMessageContainer = tooltipContainer.querySelector('.js-tooltipMessageContainer-info');

      tooltipMessageContainer.innerHTML = '';
      const allTypes = Object.keys(TOOLTIP_TYPES).map(keyName => TOOLTIP_TYPES[keyName]);
      let close = true;
      allTypes.forEach(item => {
        if (hasClass(tooltipContainer, item)) { close = false; }
      });
      if (close) {
        removeClass(questionWrapper, 'isTooltipOpen');
      }
    }
  }

  bindFormSubmit() {
    if (this.layoutParams.deviceType === 'mobile' || this.isFeedbackEmbedButton) {
      this.layoutElements.mobileSubmitButton.addEventListener('click', e => {
        e.preventDefault();
        this.submitFormWithJS(document.querySelector('.jotform-form'));
      });
    }
  }

  bindTouchSwipeEvents() {
    const swipeThreshold = 70;
    var touchEvents = {};
    const nonInputElements = ['image', 'text'];
    document.addEventListener('touchstart', e => {
      // prevent swipe when the overlay wrapper is visible
      const { overlayWrapper } = this.layoutElements;
      if (overlayWrapper && hasClass(overlayWrapper, 'isVisible')) {
        return;
      }
      // Prevent touch on fullscreen mode
      if (this.layoutParams.isFullScreenMode) return;

      let component = e.target.getAttribute('data-component');
      if (!component) {
        component = closest(e.target, 'div').getAttribute('data-component');
      }
      // let swipe for non input fields
      const swipeable = nonInputElements.indexOf(component) !== -1;
      if (swipeable || !closest(e.target, '.jfQuestion-fields')) { // prevent swipe if it started from the field itself
        touchEvents.startX = e.touches[0].screenX;
        touchEvents.startY = e.touches[0].screenY;
      }
    });
    document.addEventListener('touchmove', e => {
      touchEvents.moveX = e.touches[0].screenX;
      touchEvents.moveY = e.touches[0].screenY;
    });

    document.addEventListener('touchend', () => {
      if (touchEvents.startX !== undefined && touchEvents.startY !== undefined && !this.layoutParams.isFullScreenMode) {
        var vertical = Math.abs(touchEvents.startY - touchEvents.moveY) > swipeThreshold;
        if (this.layoutParams.cardMode !== 'scroll') {
          if (!vertical && (touchEvents.startX > touchEvents.moveX + swipeThreshold)) {
            const { formMode } = this.layoutParams;
            if (formMode === 'welcome') {
              this.setFormMode('form');
            } else {
              this.checkConditionOnCurrentCard();
              this.selectNextQuestion();
            }
          } else if (!vertical && (touchEvents.startX + swipeThreshold < touchEvents.moveX)) {
            this.selectPreviousQuestion();
          }
        }
      }
      touchEvents = {};
    });
  }

  bindResizeEvent() {
    global.addEventListener('resize', () => {
      const isAndroidDevice = this.browserProperties.isAndroid;
      const scrollElement = document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA' || document.activeElement.getAttribute('contenteditable') === 'true';
      if (isAndroidDevice && this.layoutParams.deviceType === 'mobile' && scrollElement) {
        // will be updated with polyfill
        document.activeElement.scrollIntoView();
      }
      this.disableTransitions();
      this.recalculateLayout();
      this.recalculateSmartEmbedLayout();
      this.handleFullScreenToggle();
      this.recalculateBackgroundStyle();
      setTimeout(() => {
        this.enableTransitions();
        this.updateMatrixLayout();
        this.recalculateSmartEmbedLayout();
        this.calculateWelcomeSize();
        this.recalculateCurrentCardHeight();
      }, 100);
      // we are forcing layout to resize on OS level in JotForm Next.
      if (this.isOpenedOnJotFormMobileApp) {
        // It is not a default behaviour on iOS; because of that cardforms is not resizing it.
        // This will re-calculate layout after keyboard animation only on our new(jotform next) mobile app.
        setTimeout(() => {
          this.recalculateLayout();
          this.recalculateCurrentCardHeight();
        }, 251); // native ios animation time for keyboard animations is 250ms
      }
    }, true);

    global.addEventListener('orientationchange', () => {
      setTimeout(() => {
        this.recalculateLayout();
        this.updateMatrixLayout();
        this.recalculateSmartEmbedLayout();
        this.calculateWelcomeSize();
        this.recalculateCurrentCardHeight();
      }, 1000);
    }, true);
  }

  bindHashChangeEvent() {
    global.addEventListener('hashchange', this.onLocationHashChange, true);
  }

  addScrollLeftDelta(delta) {
    if (this.layoutParams.resolutionType !== 'mobile') {
      const { currentCardIndex, currentCardSize } = this.layoutParams;
      const qCount = this.cards.filter(p => !p.isHidden).length;
      this.layoutParams.scrollLeftExtra += delta;
      const currentVisibleIndex = this.getVisibleIndex(currentCardIndex);
      const maxScroll = (currentVisibleIndex * currentCardSize) + ((qCount - 1 - currentVisibleIndex) * currentCardSize);
      const minScroll = 0; // currentVisibleIndex * (currentCardSize);
      const currentScroll = this.layoutParams.scrollLeftExtra + this.getScrollLeft();

      if (currentScroll <= minScroll) this.layoutParams.scrollLeftExtra = minScroll - this.getScrollLeft();
      if (currentScroll >= maxScroll) this.layoutParams.scrollLeftExtra = maxScroll - this.getScrollLeft();
      this.recalculateTransform();
    }
  }

  bindCardClickEvents() {
    const isMobile = this.layoutParams.deviceType === 'mobile';

    this.cards.forEach((p, index) => {
      (i => {
        p.cardContainer.addEventListener('click', () => {
          if (this.layoutParams.cardMode === 'scroll') {
            this.setCardIndex(i);
            this.setCardMode('single');

            if (!this.progress.isFormProgressVisible && !isMobile && this.progress.layoutElements.progressItemsLine && this.progress.layoutElements.progressItemWrapper) {
              addClass(this.progress.layoutElements.progressItemsLine, ' jfProgress-hiddenWrapper');
              addClass(this.progress.layoutElements.progressItemWrapper, ' jfProgress-hiddenWrapper');
            }
          }
        });
      })(index);
    });
  }

  setAddressFieldValue(card, suffixKey, val) {
    const { question: { id }, cardContainer } = card;
    const suffix = this.addressTypeSuffixMap[suffixKey];
    const field = cardContainer.querySelector(`#input_${id}_${suffix}`);
    if (field) {
      field.value = val;
      this.setFieldIsFilledIfHasValue(field);

      if (field.tagName === 'SELECT') {
        const dropdownSearchField = cardContainer.querySelector(`[data-type="${suffix}"] #jfDropdown_${id}`);
        if (dropdownSearchField) {
          dropdownSearchField.value = val;
        }
      }
    }
  }

  // Select next question if possible.
  autoSelectNextQuestion(card) {
    if ((this.isPrefilledForm && !this.isPrefillCompleted) || !this.isPrepopulationCompleted) return; // prevent autoskipping on forms during question are populating with prefill
    const { mobileNextButton, mobilePrevButton } = this.layoutElements;
    const { prev, next } = card.actionsButtons;
    // Elements for disable / enable during animations
    const elementArray = [mobilePrevButton, mobileNextButton, prev, next];
    enableDisableDOMElements(elementArray, false);
    if (this.isCardFilled(card)) {
      if (!this.autoSelectionTimeoutQueue) {
        this.autoSelectionTimeoutQueue = [];
      }
      const timeOutId = setTimeout(() => {
        if (this.autoSelectionTimeoutQueue.length > 0) {
          this.autoSelectionTimeoutQueue = this.autoSelectionTimeoutQueue.filter(timeOut => {
            if (timeOut === timeOutId) {
              clearTimeout(timeOut);
            }
            return timeOut !== timeOutId;
          });
        }
        if (this.autoSelectionTimeoutQueue.length <= 0) this.selectNextQuestion();
        enableDisableDOMElements(elementArray, true);
      }, 500);
      this.autoSelectionTimeoutQueue.push(timeOutId);
    }
  }

  bindInputChange() {
    this.cards.forEach(card => {
      if (card.question.type !== 'control_datetime') {
        const inpts = card.cardContainer.querySelectorAll('.jfInput-input, .jfRadio-input, .jfInput-textarea, .jfRating-input, .jsToggle');
        const isAutoMoveEnabledForField = this.canQuestionMoveAutomatically(card.question.type);
        for (let i = 0; i < inpts.length; i++) {
          inpts[i].addEventListener('change', event => {
            if (isAutoMoveEnabledForField && !hasClass(event.target, 'jfRadio-otherInputField') && !hasClass(event.target, 'jfRadio-otherInput')) {
              // check conditions before autoSelect
              this.checkConditionOnCurrentCard();
              this.autoSelectNextQuestion(card);
            }
            const target = event.target || event.srcElement;
            this.setFieldIsFilledIfHasValue(target);
          });
        }
      }
    });
  }

  bindSelectChange() {
    this.cards.forEach(card => {
      if (card.question.type !== 'control_datetime') {
        const selects = card.cardContainer.querySelectorAll('select.form-dropdown');
        forEach(selects, select => {
          select.addEventListener('change', event => {
            const target = event.target || event.srcElement;
            this.setFieldIsFilledIfHasValue(target);
          });
        });
      }
    });
  }

  setFieldIsFilledIfHasValue(element) {
    const fieldParent = closest(element, '.jfField', 'body');
    if (fieldParent) {
      if (element.value.length > 0 || ['select-one', 'select-multiple'].indexOf(element.type) >= 0) {
        addClass(fieldParent, 'isFilled');
      } else {
        removeClass(fieldParent, 'isFilled');
      }
    }
  }

  isEditMode() {
    return window.location.href.indexOf('/edit/') !== -1 || window.location.href.indexOf('mode=inlineEdit') !== -1;
  }

  setFormMode(nextMode, isInit, transitionsAsIs) {
    const { formMode: currMode } = this.layoutParams;
    if (currMode === nextMode) return;
    this.layoutParams.formMode = nextMode;
    if (!isInit && this.layoutElements.staticItems) {
      addClass(document.body, 'hideStaticItems');
      this.layoutElements.formWrapper.classList.remove('isBadgesVisible');
    } else if (this.layoutElements.staticItems && this.layoutElements.staticItems.children.length > 0) {
      this.layoutElements.formWrapper.classList.add('isBadgesVisible');
    }
    if (nextMode === 'form') {
      if (this.layoutElements.formWrapper) {
        this.layoutElements.formWrapper.removeAttribute('aria-hidden');
      }
      if (this.layoutParams.currentCardIndex !== 0 || this.layoutParams.resolutionType === 'mobile') {
        this.progress.layoutElements.progress.removeAttribute('aria-hidden');
        this.progress.layoutElements.progress.removeAttribute('tabindex');
      }
      if (currMode === 'welcome') {
        setTimeout(() => { this.recalculateCurrentCardHeight(); }, 400);

        if (this.sectionHeaders && this.sectionHeaders.length) {
          const sectionHeaderForFirstVisibleIndex = this.getSectionHeaderForIndex(this.getFirstVisibleIndex());
          if (
            sectionHeaderForFirstVisibleIndex
            && !sectionHeaderForFirstVisibleIndex.isHidden
            && sectionHeaderForFirstVisibleIndex.props.id.value !== 'welcomePage'
          ) {
            this.setFormMode('sectionHeader', true, false);
            return;
          }
        }

        this.hideHeader();
      }

      this.layoutParams.scaleFactor = 1;
      if (!isInit && !this.layoutParams.isLayoutAnimated && !transitionsAsIs) {
        this.enableTransitions();
      }
      if (this.layoutElements.startButton) {
        this.layoutElements.startButton.style.display = 'none';
      }
      if (this.layoutElements.previousButton) {
        this.layoutElements.previousButton.style.display = 'none';
      }
      if (!this.layoutParams.hasTouch) {
        this.focusToFirstInput(this.cards[this.layoutParams.currentCardIndex]);
      }
    } else if (nextMode === 'sectionHeader') {
      if (this.layoutElements.formWrapper) {
        this.layoutElements.formWrapper.setAttribute('aria-hidden', 'true');
      }
      if (this.layoutParams.resolutionType !== 'mobile') {
        this.progress.layoutElements.progress.setAttribute('aria-hidden', 'true');
      }
      this.updateFormHeader(this.getSectionHeaderForIndex(this.getFirstVisibleIndex()));
      this.layoutElements.startButton.style.display = 'inline';
      const logo = document.querySelector('.jfWelcome-image');
      if (logo) {
        addClass(logo, 'collapse');
      }
      // scale out the form layout for welcome and thankyou page.
      this.layoutParams.scaleFactor = 0.2;
      this.showHeader();
      setTimeout(() => {
        const nextButton = this.layoutElements.welcomeWrapper.querySelector('.forNext-heading');
        const isNotNoJump = window.location.search.indexOf('noJump') === -1;
        const firstVisibleCardIndex = this.cards.findIndex(c => c.isHidden === false);
        if (nextButton && isNotNoJump && (!this.layoutParams.isEmbed || this.layoutParams.currentCardIndex > firstVisibleCardIndex)) {
          nextButton.focus();
        }
      }, 300);
    } else {
      if (this.layoutElements.formWrapper) {
        this.layoutElements.formWrapper.setAttribute('aria-hidden', 'true');
      }
      // scale out the form layout for welcome and thankyou page.
      this.layoutParams.scaleFactor = 0.2;
      if (this.layoutElements.startButton) {
        this.layoutElements.startButton.style.display = 'inline';
      }
      if (this.layoutElements.previousButton) {
        this.layoutElements.previousButton.style.display = 'none';
      }
    }
    removeClass(document.body, 'formMode');
    removeClass(document.body, 'welcomeMode');
    removeClass(document.body, 'thankyouMode');
    removeClass(document.body, 'reviewMode');
    removeClass(document.body, 'sectionHeaderMode');
    addClass(document.body, `${this.layoutParams.formMode}Mode`);

    // this.calculateAvailableHeightForFields();
    this.calculateWelcomeSize();

    this.checkHeaderSubHeaderCharLimits(this.currentHeader);
    if (!isInit) {
      this.recalculateTransform();
    }

    this.recalculateSmartEmbedLayout();

    if (this.layoutParams.formMode === 'form' && !this.welcomePageProps.props.isFormTitleVisible) {
      this.hideHeader();
    }

    setTimeout(() => {
      this.calculateAvailableHeightForFields(); // for #1298080 workaround
      this.recalculateCurrentCardHeight();
      this.calculatePaymentHeights();
      this.recalculateSmartEmbedLayout();
      this.updateFeedbackEmbedHeight();
    }, 300);
  }

  calculatePaymentHeights() {
    if (global.JotForm.productPages) global.JotForm.productPages.initProductPages();
  }

  calculateProductsPerPage() {
    if (global.JotForm.productPages) return global.JotForm.productPages.setProductsPerPage();
  }

  addLayoutAnimation(delay) {
    if (this.layoutParams.formMode !== 'form' || !this.isTransitionsEnabled) return;
    const { cardAnimationWrapper } = this.layoutElements;
    if (delay) {
      return setTimeout(() => {
        addClass(cardAnimationWrapper, 'transition-all-03s');
        this.layoutParams.isLayoutAnimated = true;
      }, delay);
    }
    addClass(cardAnimationWrapper, 'transition-all-03s');
    this.layoutParams.isLayoutAnimated = true;
    return false;
  }

  setScale(factor) {
    this.layoutParams.scaleFactor = factor;
    this.recalculateTransform();
  }

  enableTransitions() {
    this.isTransitionsEnabled = true;
    this.addLayoutAnimation();
    this.cards.forEach(card => {
      addClass(card.wrapperContainer, 'transition-all-015s');
    });
  }

  disableTransitions() {
    this.isTransitionsEnabled = true;
    this.removeLayoutAnimation();
    this.cards.forEach(card => {
      removeClass(card.wrapperContainer, 'transition-all-015s');
    });
  }

  removeLayoutAnimation(delay) {
    const { cardAnimationWrapper } = this.layoutElements;
    if (delay) {
      if (this.removeLayoutAnimation.timeout) {
        clearTimeout(this.removeLayoutAnimation.timeout);
      }
      this.removeLayoutAnimation.timeout = setTimeout(() => {
        this.removeLayoutAnimation.timeout = null;
        removeClass(cardAnimationWrapper, 'transition-all-03s');
        this.layoutParams.isLayoutAnimated = false;
      }, delay);
    } else {
      removeClass(cardAnimationWrapper, 'transition-all-03s');
      this.layoutParams.isLayoutAnimated = false;
    }
  }

  showProgress() {
    removeClass(this.progress.layoutElements.progress, 'progress-animate');
    setTimeout(() => {
      addClass(this.progress.layoutElements.progress, 'no-animate');
      this.progress.layoutElements.progress.removeAttribute('aria-hidden');
      this.progress.layoutElements.progress.removeAttribute('tabindex');
    }, 700);

    // this.progress.layoutElements.progress.style.transform = '';
  }

  checkCardIfMoveAutomatically(card) {
    const questionType = card.question.type;
    const canMoveAuto = this.canQuestionMoveAutomatically(questionType);
    if (canMoveAuto) {
      addClass(card.cardContainer, 'canMoveAuto');
    }
  }

  canQuestionMoveAutomatically(questionType) {
    const questionTypes = ['control_radio', 'control_imagechoice', 'control_yesno', 'control_rating', 'control_scale'];
    const isExistsInArray = questionTypes.indexOf(questionType) > -1;
    // May be check mobile or desktop bla bla.
    const isAccessibleForm = global.JotForm.accessible;
    return isExistsInArray && !isAccessibleForm;
  }

  closeTimezonePicker() {
    const openTimezonePicker = document.querySelector('.jDropdownWG-wrapper:not(.isClose)');

    if (openTimezonePicker) {
      openTimezonePicker.classList.add('isClose');
    }
  }

  selectNextQuestion(ignoreValidation, withoutTransition = false) {
    const { currentCardIndex, cardMode, formMode } = this.layoutParams;

    if (formMode === 'sectionHeader') {
      this.setFormMode('form');
      this.updateFormHeader(this.getSectionHeaderForIndex(currentCardIndex));
      return;
    }

    if (currentCardIndex > -1) {
      if (cardMode === 'scroll' || !!ignoreValidation || this.validateCard(this.cards[currentCardIndex])) {
        this.showProgress();

        let nextVisibleIndex = currentCardIndex + 1;
        while (nextVisibleIndex < this.cards.length && this.cards[nextVisibleIndex].isHidden) {
          nextVisibleIndex++;
        }

        if (this.layoutElements.staticItems) {
          this.layoutElements.formWrapper.classList.remove('isBadgesVisible');
          addClass(document.body, 'hideStaticItems');
        }

        let jumpToQuestionPageTriggered = true;

        if (global.JotForm.nextPage) {
          jumpToQuestionPageTriggered = false;
          let skipIndex = currentCardIndex;
          const nextPageId = global.JotForm.nextPage.id.substring(global.JotForm.nextPage.id.indexOf('_') + 1);

          for (let i = 0; i < this.cards.length; i++) {
            if (this.cards[i].question.id === nextPageId) {
              skipIndex = i;
              break;
            }
            this.cards[i].formLine.removeAttribute('data-skipped-by');
          }
          nextVisibleIndex = skipIndex;
          if (global.JotForm.headerInBetween) {
            jumpToQuestionPageTriggered = true;
          }
          global.JotForm.nextPage = false;
        }

        if (nextVisibleIndex < this.cards.length) {
          const [currentHeader, nextHeader] = [this.getSectionHeaderForIndex(currentCardIndex), this.getSectionHeaderForIndex(nextVisibleIndex)];

          if (cardMode !== 'scroll' && currentHeader !== nextHeader && !nextHeader.isHidden && jumpToQuestionPageTriggered) {
            this.setFormMode('sectionHeader');

            this.calculateWelcomeSize();

            this.updateFormHeader(nextHeader);
            this.setCardIndex(nextVisibleIndex, false);
          } else {
            this.setCardIndex(nextVisibleIndex, withoutTransition);
          }

          this.cards[nextVisibleIndex].prevCard = this.cards[currentCardIndex].question;

          if (cardMode === 'scroll') {
            this.removeLayoutAnimation(400); // provide free scroll without transitions
          }

          if (this.cards[currentCardIndex].question.type === 'control_appointment') {
            this.closeTimezonePicker();
          }
        }
      } else {
        this.shakeCard(currentCardIndex);
        this.focusToFirstError(currentCardIndex);
      }
    }
  }

  focusToFirstError(cardIndex) {
    const erroreousInput = this.cards[cardIndex].cardContainer.querySelector('.form-validation-error');
    if (erroreousInput) {
      erroreousInput.focus();
    }
  }

  selectPreviousQuestion() {
    const { currentCardIndex, cardMode, formMode } = this.layoutParams;
    if (formMode === 'sectionHeader') return;
    let prevVisibleIndex = currentCardIndex - 1;
    while (prevVisibleIndex > -1 && this.cards[prevVisibleIndex].isHidden) {
      prevVisibleIndex--;
    }

    // If the current card has prevCard, it will go back to the this page
    if (currentCardIndex > -1 && this.cards[currentCardIndex].prevCard) {
      prevVisibleIndex = this.cards.findIndex(card => card.question.id === this.cards[currentCardIndex].prevCard.id && !card.isHidden);
      this.cards[currentCardIndex].prevCard = null;
    }

    if (prevVisibleIndex > -1) {
      this.setCardIndex(prevVisibleIndex);
      if (cardMode === 'scroll') {
        this.removeLayoutAnimation(400); // provide free scroll without transitions
      }
    }
  }

  bindPrevNextButtonsClick() {
    // const actionContainer = document.querySelectorAll('.jfCard-actions');
    document.body.addEventListener('click', e => {
      if (hasClass(e.target, 'forNext') || hasClass(e.target, 'forMobileNav')) {
        this.checkConditionOnCurrentCard();
      }

      if (hasClass(e.target, 'forNext')) {
        e.preventDefault();
        this.selectNextQuestion();
      } else if (hasClass(e.target, 'forPrev')) {
        e.preventDefault();
        this.selectPreviousQuestion();
      }
    });
  }

  findEmailAnswer() {
    const emailCards = this.cards.filter(card => card.question.type === 'control_email' && !card.isHidden && !card.hasError);

    if (emailCards.length === 0) {
      return '';
    }
    return emailCards[0].fieldContainer.querySelector('input[type="email"]').value;
  }

  bindKeyUpEvent() {
    document.addEventListener('keydown', e => {
      const { overlayWrapper } = this.layoutElements;
      if (overlayWrapper && hasClass(overlayWrapper, 'isVisible')) {
        return;
      }
      const { formMode, cardMode, currentCardIndex } = this.layoutParams;
      const currentQuestion = this.cards[currentCardIndex] ? this.cards[currentCardIndex].question : {};
      const disallowedKeyCodes = fieldRelatedNavigationKeyCodes[e.target.tagName];
      const { activeElement } = document;
      const { isContentEditable } = activeElement;
      const disableEnterEvent = activeElement.getAttribute('data-disable-enter-event');
      const disableEscapeEvent = activeElement.getAttribute('data-disable-escape-event');
      const hasActiveAutoSelectAnimation = this.autoSelectionTimeoutQueue && Array.isArray(this.autoSelectionTimeoutQueue) && this.autoSelectionTimeoutQueue.length > 0;
      if (!hasActiveAutoSelectAnimation && (!disallowedKeyCodes || disallowedKeyCodes.indexOf(e.keyCode) === -1 || !e.target.value)) {
        if (
          !disableEscapeEvent && (
            (e.keyCode === 27 && this.layoutParams.isFullScreenMode)
            || (e.keyCode === 13 && e.shiftKey && (e.metaKey || e.altKey))
          )
        ) {
          if (formMode === 'form' && cardMode === 'single') {
            this.toggleFullScreenMode();
          }
          return;
        }

        // Don't respond to other shortcuts when full screen mode is enabled.
        if (this.layoutParams.isFullScreenMode) { return; }

        if (e.keyCode === 13 || e.keyCode === 39) {
          this.checkConditionOnCurrentCard();
        }

        if (!isContentEditable && !disableEnterEvent) {
          if ((e.keyCode === 39 || e.keyCode === 13) && !document.getElementById('isStripeACHVerification')) {
            if ((this.layoutParams.formMode === 'welcome' || this.layoutParams.formMode === 'sectionHeader') && e.keyCode === 13) {
              this.setFormMode('form');
              this.shortenHeaders();
              e.preventDefault();
            } else if (this.layoutParams.cardMode === 'scroll' && e.keyCode === 13) {
              this.setCardIndex(this.getNearestCardIndexInScrollMode());
              this.setCardMode('single');
            } else if (e.keyCode === 13 && currentQuestion.type === 'control_address' && activeElement
            && (activeElement === document.body || activeElement.id === `input_${currentQuestion.id}_addr_search`)) {
              e.preventDefault();
            } else {
              e.preventDefault();
              this.selectNextQuestion();
            }
          } else if (e.keyCode === 37) {
            if (this.layoutParams.formMode === 'sectionHeader') {
              this.setFormMode('form');
            }
            this.selectPreviousQuestion();
          }
        }
      }
    });
  }

  getNearestCardIndexInScrollMode() {
    const { scrollLeftExtra, currentCardIndex, currentCardSize } = this.layoutParams;
    const scaledCardSize = currentCardSize; // * cardScrollScale;
    const addedIndex = parseInt(Math.abs(scrollLeftExtra) / scaledCardSize, 10);
    const left = (Math.abs(scrollLeftExtra) % scaledCardSize) > (scaledCardSize / 2) ? 1 : 0;
    let indexDiff = addedIndex + left;
    let hiddenCountInBetween = 0;

    if (scrollLeftExtra > 0) {
      for (let i = currentCardIndex + 1; i < this.cards.length && indexDiff > 0; i++) {
        if (this.cards[i].isHidden) {
          hiddenCountInBetween++;
        } else {
          indexDiff--;
        }
      }
      return (currentCardIndex + addedIndex + left) + hiddenCountInBetween;
    }

    for (let i = currentCardIndex - 1; i >= 0 && indexDiff > 0; i--) {
      if (this.cards[i].isHidden) {
        hiddenCountInBetween++;
      } else {
        indexDiff--;
      }
    }
    return (currentCardIndex - (addedIndex + left)) - hiddenCountInBetween;
  }

  shakeCard(cardIndex) {
    const card = this.cards[cardIndex].cardContainer;
    addClass(card, 'animate-shake');

    setTimeout(() => {
      removeClass(card, 'animate-shake');
    }, 400);
  }

  setCardMode(mode, withoutTransition) {
    const { cardAnimationWrapper } = this.layoutElements;
    this.layoutParams.cardMode = mode;
    if (this.layoutParams.cardMode === 'scroll') {
      addClass(this.layoutElements.cardAnimationWrapper, 'noselect');
      this.removeLayoutAnimation(400); // remove animations in scroll mode to provide clean & free scrolling
      addClass(cardAnimationWrapper, 'onScrollMode');
      addClass(document.body, 'onScrollMode');
      global.addEventListener('wheel', this.onWheel, { passive: false });
      this.calculateAllCardsHeight();
    } else {
      removeClass(this.layoutElements.cardAnimationWrapper, 'noselect');
      if (!withoutTransition) {
        // enable animations in 'single' mode
        this.addLayoutAnimation();
        setTimeout(() => { this.recalculateSmartEmbedLayout(); }, 300);
        // clear any delayed animation removal timeout
        clearTimeout(this.removeLayoutAnimation.timeout);
      } else {
        this.recalculateSmartEmbedLayout();
      }
      removeClass(cardAnimationWrapper, 'onScrollMode');
      removeClass(document.body, 'onScrollMode');
      global.removeEventListener('wheel', this.onWheel, { passive: false });
    }
    this.recalculateTransform();
  }

  onWheel(e) {
    const { cardMode, resolutionType } = this.layoutParams;
    if (cardMode === 'scroll' && resolutionType !== 'mobile') {
      e.preventDefault();
      this.addScrollLeftDelta(Math.abs(e.deltaY) > Math.abs(e.deltaX) ? e.deltaY : e.deltaX);
    }
  }

  selectQuestion(index) {
    this.setCardMode('scroll');

    setTimeout(() => {
      this.setCardIndex(index);
    }, 400);

    setTimeout(() => {
      this.setCardMode('single');
    }, 800);
  }

  getTotalWidth() {
    const questionCount = this.cards.filter(p => !p.isHidden).length;
    return `${(questionCount * this.layoutParams.currentCardSize) + this.layoutParams.leftMargin}px`;
  }

  getVisibleIndex(index) {
    const invisibleCountToIndex = this.cards.slice(0, index).reduce((acc, card) => {
      return card.isHidden ? acc + 1 : acc;
    }, 0);

    return index - invisibleCountToIndex;
  }

  getScrollLeft() {
    return this.layoutParams.currentCardSize * this.getVisibleIndex(this.layoutParams.currentCardIndex);
  }

  setWrapperWidth() {
    const { cardAnimationWrapper } = this.layoutElements;
    const { currentCardSize, leftMargin } = this.layoutParams;
    cardAnimationWrapper.style.width = this.getTotalWidth();
    this.cards.forEach((card, index) => {
      const wrapper = card.wrapperContainer;
      wrapper.style.width = `${currentCardSize}px`;
      if (this.layoutParams.for1Template || this.getVisibleIndex(index) === 0) {
        wrapper.style.marginLeft = `${leftMargin}px`;
      } else {
        wrapper.style.marginLeft = '0px';
      }
    });
  }

  // Returns current orientation type of the device
  // ['portrait-primary', 'portrait-secondary', 'landscape-primary', 'landscape-seconday']
  getCurrentOrientation() {
    const { screen, orientation } = global;
    const screenOrientation = screen.orientation || screen.mozOrientation || screen.msOrientation;
    if (screenOrientation && typeof screenOrientation.type === 'string') {
      // defaults: desktop -> landscape-primary, mobile -> portratir-primary
      return screenOrientation.type;
    }

    // Lets calculate from angle for old browsers
    const orientationAngle = orientation || (screenOrientation && screenOrientation.angle) || 0;
    return calculateOrientationType(orientationAngle);
  }

  // This function uses bowser library, and adds necessary classes to body.
  checkAndSetBrowserBasedClasses() {
    const classNames = ['browserName-', 'browserVersion-', 'browserType-', 'isWebKit', 'osName-', 'osVersion-', 'browserOrientation-'];
    const [orientationType] = this.getCurrentOrientation().split('-');
    const currentClasses = document.body.className.split(' ');
    const newClasses = [
      // Somehow split join is faster than replace global o_O
      `browserName-${this.browserProperties.browserName.split(' ').join('')}`,
      `browserVersion-${this.browserProperties.browserVersion}`,
      `browserOrientation-${orientationType}`
    ];
    if (this.browserProperties.isWebkit) {
      newClasses.push('isWebKit');
    }
    if (this.browserProperties.isMobile || this.browserProperties.isTablet) {
      newClasses.push(`browserType-${this.browserProperties.isMobile ? 'mobile' : 'tablet'}`);
    }
    if (this.browserProperties.osName) {
      newClasses.push(`osName-${this.browserProperties.osName}`);
    }
    if (this.browserProperties.osVersion) {
      newClasses.push(`osVersion-${this.browserProperties.osVersion}`);
    }
    classNames.forEach(cname => {
      const currentClassName = currentClasses.find(c => c.indexOf(cname) > -1);
      const newClassName = newClasses.find(c => c.indexOf(cname) > -1);
      if (currentClassName !== newClassName) {
        if (currentClassName) { removeClass(document.body, currentClassName); }
        if (newClassName) { addClass(document.body, newClassName); }
      }
    });
  }

  checkAndSetDeviceType() {
    var viewportWidth = window.innerWidth || window.screen.width;
    if (viewportWidth <= deviceSize.cardwidthp) {
      this.layoutParams.resolutionType = 'mobile';
    } else if (viewportWidth <= deviceSize.cardwidthpt) {
      this.layoutParams.resolutionType = 'mobile';
    } else if (viewportWidth <= deviceSize.cardwidtht) {
      this.layoutParams.resolutionType = '';
    } else if (viewportWidth <= deviceSize.cardwidthsm) {
      this.layoutParams.resolutionType = '';
    } else if (viewportWidth <= deviceSize.cardwidthm) {
      this.layoutParams.resolutionType = '';
    } else if (viewportWidth <= deviceSize.cardwidthxl) {
      this.layoutParams.resolutionType = '';
    } else {
      this.layoutParams.resolutionType = '';
    }
    this.checkAndSetBrowserBasedClasses();
  }

  recalculateLayout() {
    const { cardAnimationWrapper } = this.layoutElements;
    this.checkAndSetDeviceType();

    let currentCardSize;
    var viewportWidth = window.innerWidth || window.screen.width;

    if (viewportWidth <= deviceSize.cardwidthp) {
      currentCardSize = cardSize.cardwidthp;
    } else if (viewportWidth <= deviceSize.cardwidthpt) {
      currentCardSize = cardSize.cardwidthpt;
    } else if (viewportWidth <= deviceSize.cardwidtht) {
      currentCardSize = cardSize.cardwidtht;
    } else if (viewportWidth <= deviceSize.cardwidthsm) {
      currentCardSize = cardSize.cardwidthsm;
    } else if (viewportWidth <= deviceSize.cardwidthm) {
      currentCardSize = cardSize.cardwidthm;
    } else if (viewportWidth <= deviceSize.cardwidthxl) {
      currentCardSize = cardSize.cardwidthxl;
    } else {
      currentCardSize = cardSize.cardwidthxl;
    }

    // handle percentage width
    if ((typeof currentCardSize) === 'string' && currentCardSize.indexOf('%') > -1) {
      currentCardSize = viewportWidth * (+(currentCardSize.replace('%', '')) / 100);
    }

    this.layoutParams.leftMargin = (viewportWidth - currentCardSize) / 2;
    this.layoutParams.currentCardSize = currentCardSize;

    cardAnimationWrapper.style.width = this.getTotalWidth();
    this.setWrapperWidth();
    this.calculateAvailableHeightForFields();

    this.recalculateTransform();

    // update feedback button height
    this.updateFeedbackEmbedHeight();
  }

  recalculateBackgroundStyle() {
    const formWrapper = document.querySelector('.jfForm-backgroundContainer') || document.querySelector('.jfForm-wrapper');
    const progressWrapper = document.querySelector('.jfProgress#cardProgress');
    const viewportWidth = global.window.innerWidth || global.window.screen.width;
    const viewportHeight = global.window.innerHeight || global.window.screen.height;
    const currentOrientation = viewportWidth > viewportHeight ? 'landscape' : 'portrait'; // Not using getCurrentOrientation due to limited browser support.

    if (this.layoutParams.resolutionType === 'mobile') {
      if (!this.layoutParams.isEmbed) {
        const backgroundStyle = (() => {
          switch (currentOrientation) {
            case 'landscape':
              return { size: 'cover', position: 'center' };
            case 'portrait':
              return { size: `auto ${viewportHeight + 1}px`, position: 'top center' };
            default:
              return null;
          }
        })();
        formWrapper.style.backgroundSize = backgroundStyle.size;
        formWrapper.style.backgroundPosition = backgroundStyle.position;
        progressWrapper.style.backgroundSize = backgroundStyle.size;
        progressWrapper.style.backgroundPosition = backgroundStyle.position;
      }
    } else {
      formWrapper.style.backgroundSize = null;
      formWrapper.style.backgroundPosition = null;
      progressWrapper.style.backgroundSize = null;
      progressWrapper.style.backgroundPosition = null;
    }
  }

  getXPos(event) {
    if (event.clientX) {
      return event.clientX;
    }
    if (event.touches && event.touches.length) {
      return event.touches[0].clientX;
    }
    return 0;
  }

  mouseDown(e) {
    if (this.layoutParams.cardMode === 'scroll') {
      this.layoutParams.isDraggingStart = true;
      this.layoutParams.dragStartX = this.getXPos(e);
    }
  }

  mouseUp() {
    if (this.layoutParams.cardMode === 'scroll') {
      this.layoutParams.isDraggingStart = false;
      setTimeout(() => {
        this.layoutParams.isDragging = false;
      }, 10);
    }
  }

  mouseMove(e) {
    if (this.layoutParams.cardMode === 'scroll' && this.layoutParams.isDraggingStart) {
      this.layoutParams.isDragging = true;
      const delta = this.layoutParams.dragStartX - this.getXPos(e);
      this.layoutParams.dragStartX = this.getXPos(e);
      this.addScrollLeftDelta(delta);
    }
  }

  bindDragPage() {
    document.body.addEventListener('mousedown', this.mouseDown);
    document.body.addEventListener('mouseup', this.mouseUp);
    document.body.addEventListener('mousemove', this.mouseMove);
    document.body.addEventListener('touchstart', this.mouseDown);
    document.body.addEventListener('touchend', this.mouseUp);
    document.body.addEventListener('touchmove', this.mouseMove);
    document.body.addEventListener('pointerdown', this.mouseDown);
    document.body.addEventListener('pointerup', this.mouseUp);
    document.body.addEventListener('pointermove', this.mouseMove);
  }

  onFieldVisibilityChanged(success, isVisible, ...params) {
    const [id] = params;
    const ids = Array.isArray(id) ? id : [id];

    // filter cards to update visibility - skip if incoming visibility is same
    let cardsToUpdate = this.cards.filter(p => ids.includes(p.question.id) && p.isHidden === isVisible);

    if (success && cardsToUpdate) {
      const lengthClass = (this.visibleCards.length > 116 && 'isVeryLongForm') || (this.visibleCards.length > 72 && 'isLongForm');
      const classesToRemove = (this.visibleCards.length > 116 && ['isLongForm']) || (this.visibleCards.length > 72 && ['isVeryLongForm']) || ['isLongForm', 'isVeryLongForm'];

      if (lengthClass) {
        addClass(document.body, lengthClass);
      }

      classesToRemove.forEach(className => removeClass(document.body, className));

      // filter out cards that forced to be hidden
      if (isVisible) {
        cardsToUpdate = cardsToUpdate.filter(p => !p.forceHide);
      }

      if (cardsToUpdate.length) {
        this.setCardVisibility(cardsToUpdate, isVisible);
      }
    }

    if (cardsToUpdate.length === 0 && this.sectionHeaders && this.sectionHeaders.length) {
      // check if its section header
      const headers = this.sectionHeaders.filter(p => ids.includes(p.props.id.value));
      headers.forEach(header => {
        if (header && !!header.isHidden === !!isVisible) {
          header.isHidden = !isVisible; // eslint-disable-line no-param-reassign
          if (!isVisible && this.layoutParams.formMode !== 'welcome') {
            this.setFormMode('form');
          }
        }
      });
    }
  }

  setCardVisibility(_card, isVisible) {
    const cards = Array.isArray(_card) ? _card : [_card];

    // remove animations for immadiate layout transformation
    this.removeLayoutAnimation();
    this.cards.forEach(card => {
      removeClass(card.wrapperContainer, 'transition-all-015s');
    });
    // ////////////////////////////////////////////////

    const hiddenIndexes = !isVisible ? cards.map(p => this.cards.indexOf(p)) : [];
    cards.forEach(card => {
      card.isHidden = !isVisible; // eslint-disable-line no-param-reassign
      this.progress.setIndexVisibility(this.cards.indexOf(card), isVisible);
    });

    this.progress.setCurrentIndexText();
    this.progress.setFirstLastCellClasses();
    this.progress.setQuestionOrderNumbers();
    this.progress.showProgressBarIfNeeded();

    this.setPrevNextQuestion(this.layoutParams.currentCardIndex);
    this.setWrapperWidth();
    this.recalculateTransform();

    // update card indexes
    this.updateCardIndexes();

    // enable animations
    setTimeout(() => {
      this.enableTransitions();
    }, 50);
    // /////////////////////

    // if hidden field is current field select next visible field
    if (hiddenIndexes.indexOf(this.layoutParams.currentCardIndex) > -1) {
      let nextVisibleIndex = -1;
      for (let i = 1; i < this.cards.length; i++) {
        const currentIndex = (this.layoutParams.currentCardIndex + i) % this.cards.length;
        if (!this.cards[currentIndex].isHidden) {
          nextVisibleIndex = currentIndex;
          break;
        }
      }

      if (nextVisibleIndex > -1) {
        this.setCardIndex(nextVisibleIndex);
      } else {
        console.warn('no visible card exists'); // eslint-disable-line
      }
    }

    // update card labels
    this.updateCardLabels();
    this.repositionActionButtons();
  }

  updateCardIndexes() {
    this.cards.forEach((_card, index) => {
      const card = _card;
      card.indexContainer.textContent = this.getVisibleIndex(index) + 1;
    });
  }

  getCardLabels() {
    const labels = [];
    forEach(this.visibleCards, (card, index) => {
      const _card = card;
      const labelContainer = card.cardContainer.querySelector('.jfQuestion-label');

      if (labelContainer && labelContainer.childNodes && labelContainer.childNodes[0]) {
        labels.push({
          question: _card.question,
          label: labelContainer.childNodes[0].textContent
        });
      } else {
        labels.push({
          question: _card.question,
          label: `Question ${index + 1}`
        });
      }
    });

    return labels;
  }

  updateCardLabels() {
    forEach(this.visibleCards, (card, index) => {
      const _card = card;
      const labelContainer = card.cardContainer.querySelector('.jfQuestion-label');

      if (labelContainer && labelContainer.childNodes && labelContainer.childNodes[0]) {
        _card.label = labelContainer.childNodes[0].textContent;
      } else {
        _card.label = `Question ${index + 1}`;
        if (_card.type === Payment.paymentCards.creditCard) {
          _card.label = 'Credit Card';
        }
      }
    });

    if (this.progress) { this.progress.setQuestionOrderNumbers(); }
  }

  onRequireField(id, isRequired) {
    const cards = this.cards.filter(p => p.question.id === id);
    cards.forEach(card => {
      const { cardContainer } = card;
      const requiredElement = cardContainer.querySelector('.jfRequiredStar');
      if (isRequired) {
        if (requiredElement) {
          requiredElement.style.display = 'initial';
        } else {
          this.addRequiredElementToCard(cardContainer);
        }
      } else {
        if (requiredElement) {
          requiredElement.style.display = 'none';
        }
        if (card.hasError) {
          this.updateCardStatus(card);
        } else {
          this.updateCardStatus(card, false, false);
        }
      }
    });
  }

  addRequiredElementToCard(cardElement) {
    const span = document.createElement('span');
    span.className = 'jfRequiredStar';
    const messageSpan = document.createElement('span');
    messageSpan.className = 'jfRequiredStar-message';
    messageSpan.textContent = 'This field is required';
    span.appendChild(document.createTextNode('*'));
    span.appendChild(messageSpan);

    const labelElement = cardElement.querySelector('.jfQuestion-label');
    if (labelElement) {
      labelElement.appendChild(span);
    }
  }

  updateCardStatus(card, checkValid = true, checkIsFilled = true) {
    const index = this.cards.indexOf(card);
    this.progress.unsetInvalidIndex(index);
    this.progress.unsetValidIndex(index);
    if (checkValid) this.validateCard(card);
    if (checkIsFilled) this.isCardFilled(card);
    if (card.hasError) {
      this.progress.setInvalidIndex(index);
    } else if (card.isFilled || NonInputFields.indexOf(card.question.type) > -1) {
      this.progress.setValidIndex(index);
    }
  }

  // setEnterButton(card, show) {
  //   const span = card.cardContainer.querySelector('.jfCard-actions').querySelector('span');
  //   const showButton = (this.isCardFilled(card) && this.validateCard(card)) || !!show ? '' : 'none';
  //   span.style.display = showButton;
  // }

  bindFocusOnMobileWithKeyboard() {
    function handleKeyPress() {
      if (hasTouch()) {
        let formLine = document.querySelector('.form-line .isVisible').parentElement;
        if (hasClass(document.body, 'isFullScreen')) {
          formLine = document.querySelector('.forFullScreen');
        }
        // Textarea with markdown editor focus is a bit different from regular one
        if (formLine.getAttribute('data-type') === 'control_textarea') {
          // Check editable div and if exists focus on it
          const editableTextareaDiv = formLine.querySelector('.jfTextarea-editor');
          if (editableTextareaDiv) {
            return editableTextareaDiv.focus();
          }
        }

        const focusElements = formLine.querySelectorAll('input');
        const isFocused = (document.activeElement.localName.indexOf('input') > -1) || (document.activeElement.classList.toString().indexOf('jfInput') > -1);
        if (focusElements && focusElements.length > 0 && !isFocused) {
          focusElements[0].focus();
        }
      }
    }
    document.onkeypress = handleKeyPress.bind(this);
  }

  focusToFirstInput(card) {
    if (card) {
      const { browserName, forTemplate } = this.layoutParams;

      const firstVisibleCardIndex = this.cards.findIndex(c => c.isHidden === false);
      if (
        (!this.layoutParams.isEmbed || this.layoutParams.currentCardIndex > firstVisibleCardIndex)
        && this.layoutParams.cardMode === 'single' && !forTemplate && !(card.type === 'products')) {
        const isTextArea = card.question && card.question.type === 'control_textarea';
        const selectionQuery = isTextArea && card.markdownEditor ? `#${card.question.qid}_editor` : 'input,textarea,select[class*="jfInput"]';
        const focusElement = card.cardContainer.querySelector(selectionQuery);

        setTimeout(() => {
          if (focusElement) focusElement.focus();

          // Ticket #1354844: First focus fix for safari
          if (isTextArea && card.markdownEditor && ['Safari', 'Firefox'].indexOf(browserName) > -1) {
            card.markdownEditor.saveSelection();
          }
        }, 500);
      }
    }
  }

  onEnableDisableField(id, enable) {
    const cards = this.cards.filter(p => p.question.id === id);
    cards.forEach(_card => {
      const card = _card;
      card.isDisabled = !enable;
      const { cardContainer } = card;
      const question = cardContainer.querySelector('.jfCard-question');
      const jfQuestionFields = cardContainer.querySelector('.jfQuestion-fields');

      if (jfQuestionFields.getAttribute('data-component') === 'matrix') {
        const tableRows = cardContainer.querySelectorAll('.jfMatrixTable-row');
        tableRows.forEach(element => {
          const tableRow = element;
          tableRow.style.pointerEvents = enable ? 'inherit' : 'none';
        });
        const columnDotListText = cardContainer.querySelector('.jfMatrixProgress-text');
        if (columnDotListText && columnDotListText.style.display && columnDotListText.style.display === 'none') {
          columnDotListText.style.removeProperty('display');
        }
        const jfMatrixPrevButton = cardContainer.querySelector('.jfMatrixProgress-button.forMatrixPrev.js-mobileMatrixPrevButton.noTranslate.conditionallyDisabled');
        if (jfMatrixPrevButton && jfMatrixPrevButton.disabled) {
          jfMatrixPrevButton.disabled = false;
        }
        const jfMatrixNextButton = cardContainer.querySelector('.jfMatrixProgress-button.forMatrixNext.js-mobileMatrixNextButton.noTranslate.conditionallyDisabled');
        if (jfMatrixNextButton && jfMatrixNextButton.disabled) {
          jfMatrixNextButton.disabled = false;
        }
      } else {
        question.style.pointerEvents = enable ? 'inherit' : 'none';
      }

      const questionsThatNeedBlocker = ['control_textarea', 'control_matrix'];
      const forMobile = cardContainer.querySelectorAll('.jfMatrix.forMobile.forClassic')[0];
      const forMobileCheck = forMobile && (forMobile.matches('.jfMatrix.forMobile.forClassic.hidden-matrix'));
      // If the matrix is opened by mobil and hidden
      // should be not removed matrix events
      if (questionsThatNeedBlocker.indexOf(card.question.type) > -1 && forMobileCheck) {
        setTimeout(() => {
          const listener = enable ? question.removeEventListener : question.addEventListener;
          [
            'click',
            'mousedown',
            'mouseup',
            'mousemove',
            'touchstart',
            'touchend',
            'touchmove',
            'keydown',
            'keyup',
            'pointerup',
            'pointerdown',
            'pointermove'
          ].forEach(eventName => {
            listener.call(question, eventName, this.eventBlocker, true);
          });
        }, 500);
      }

      // jotform disables all elements under <li>. We dont want to disable card next prev actions
      // so enable elements under actions container action
      const checkjfQuestionField = cardContainer.querySelector('.jfQuestion-fields, [data-wrapper-react=true]');
      const checkjfCardAction = cardContainer.querySelector('.jfCard-actions');
      if (checkjfQuestionField && checkjfCardAction) {
        if (enable) {
          checkjfQuestionField.style.opacity = 1;
          return;
        }
        const buttons = checkjfCardAction.querySelectorAll('button');
        forEach(buttons, button => {
          removeClass(button, 'conditionallyDisabled');
          button.disabled = false; // eslint-disable-line
        });
        checkjfQuestionField.style.opacity = 0.5;
      }
    });
  }

  eventBlocker(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  renderReCaptcha(captchaMode) {
    window.onload = () => {
      if (global.grecaptcha) {
        if ((captchaMode === 'recaptcha_invisible' || captchaMode === 'invisibleFromAdvancedSettings')) {
          const recaptchaInvisible = document.querySelector('#recaptcha_invisible');
          if (recaptchaInvisible) {
            if (captchaMode === 'invisibleFromAdvancedSettings') {
              recaptchaInvisible.addClassName('u-hidden');
            }
            global.grecaptcha.render(recaptchaInvisible, {
              sitekey: '6LcG3CgUAAAAAGOEEqiYhmrAm6mt3BDRhTrxWCKb',
              size: 'invisible',
              badge: 'inline',
              callback: this.recaptchaCallback
            });
          }
        } else if (captchaMode === 'recaptcha_visible' && document.querySelector('#recaptcha_visible')) {
          global.grecaptcha.render('recaptcha_visible', {
            sitekey: '6LdU3CgUAAAAAB0nnFM3M3T0sy707slYYU51RroJ',
            size: this.layoutParams.currentCardSize < 385 ? 'compact' : 'normal'
          });
          const reCaptchaResponseField = document.querySelector('.g-recaptcha-response');
          if (reCaptchaResponseField) {
            reCaptchaResponseField.addClassName('validate[required]');
            global.JotForm.setFieldValidation(reCaptchaResponseField);
          }
        } else if (captchaMode === 'hcaptcha_visible' && document.querySelector('#hcaptcha_visible')) {
          global.grecaptcha.render('hcaptcha_visible', {
            sitekey: '772f4a50-7161-425e-8cd5-4d7e361ab765',
            size: this.layoutParams.currentCardSize < 385 ? 'compact' : 'normal'
          });
          const hCaptchaResponseField = document.querySelector('[name="h-captcha-response"]');
          if (hCaptchaResponseField) {
            hCaptchaResponseField.addClassName('validate[required]');
            global.JotForm.setFieldValidation(hCaptchaResponseField);
          }
        }
      }
    };
  }

  recaptchaCallback() {
    global.captchaFilled = true;
    this.submitFormWithJS(document.querySelector('.jotform-form'));
  }

  hcaptchaCallback() {
    global.captchaFilled = true;
    this.submitFormWithJS(document.querySelector('.jotform-form'));
  }

  submitFormWithJS(form) {
    if (this.layoutParams.deviceType !== 'mobile' || (this.layoutParams.deviceType === 'mobile' && global.JotForm.validateAll())) {
      global.JotForm.disableButtons();
    }
    const button = form.ownerDocument.createElement('input');
    button.style.display = 'none';
    button.type = 'submit';
    form.appendChild(button).click();
    form.removeChild(button);
  }

  onCreditCardAddressVisibilityChanged(isVisible) {
    const cards = this.cards.filter(p => p.type === Payment.paymentCards.creditCard || p.type === Payment.paymentCards.address);
    if (cards && cards.length) {
      cards.forEach(_card => {
        const card = _card;
        card.forceHide = !isVisible;
        card.wrapperContainer.style.display = isVisible ? 'block' : 'none';
      });

      this.setCardVisibility(cards, isVisible);
    }
  }

  setCardActionMode(_card, mode) {
    const card = _card;
    card.actionsButtons.mode = mode;
    card.actionsButtons.prev.style.display = mode === 'last' || mode === 'middle' ? 'block' : 'none';
    card.actionsButtons.next.style.display = mode === 'first' || mode === 'middle' ? 'block' : 'none';
    card.actionsButtons.submit.style.display = mode === 'last' || mode === 'submit' ? 'block' : 'none';

    // if submit button is displayed add 'form-submit-button' class otherview remove
    if (card.actionsButtons.submit.style.display === 'block') {
      addClass(card.actionsButtons.submit, 'form-submit-button');
      // reserve original text[1393090], this is done initially inside jotform.js for '.form-submit-button'
      if (!hasClass(card.actionsButtons.submit, 'for-upload')) {
        card.actionsButtons.submit.oldText = card.actionsButtons.submit.innerHTML;
      }
    } else {
      removeClass(card.actionsButtons.submit, 'form-submit-button');

      if (hasClass(card.actionsButtons.submit, 'for-upload')) {
        removeClass(card.actionsButtons.submit, 'for-upload');
        card.actionsButtons.submit.innerHTML = card.actionsButtons.submit.oldText;
      }
    }

    // hide actual submit button to show dummy useJotformSign button
    if (global.useJotformSign === 'Yes' && !this.layoutParams.reviewBeforeSubmit) {
      const jotformSignButton = card.cardContainer.querySelector('.useJotformSign-button');
      if (mode === 'last' || mode === 'submit') {
        jotformSignButton.style.display = 'block';
        jotformSignButton.id = 'useJotformSign-button';
        jotformSignButton.oldText = jotformSignButton.innerHTML;
        card.actionsButtons.submit.style.display = 'none';
        return;
      }
      jotformSignButton.style.display = 'none';
    }
  }

  repositionActionButtons() {
    const firstVisibleIndex = this.getFirstVisibleIndex();

    if (firstVisibleIndex === -1) return;

    let lastVisibleIndex = 0;
    for (let i = this.cards.length - 1; i >= 0; i--) {
      if (!this.cards[i].isHidden) {
        lastVisibleIndex = i;
        break;
      }
    }

    this.setMobilePrevNextQuestionButtons(this.layoutParams.currentCardIndex);
    if (firstVisibleIndex === lastVisibleIndex) {
      return this.setCardActionMode(this.cards[firstVisibleIndex], 'submit');
    }

    this.setCardActionMode(this.cards[firstVisibleIndex], 'first');
    this.setCardActionMode(this.cards[lastVisibleIndex], 'last');

    this.cards.slice(firstVisibleIndex + 1, lastVisibleIndex).forEach(card => {
      this.setCardActionMode(card, 'middle');
    });
  }

  shortenHeaders() {
    // Shortening should be done if only and only if in the form mode!
    if (this.layoutParams.formMode !== 'form') return;

    const headerWrapper = this.layoutElements.welcomeWrapper.querySelector('#header_welcomePage');
    const subHeaderWrapper = this.layoutElements.welcomeWrapper.querySelector('#subHeader_welcomePage');

    this.shortenElementContent(headerWrapper, 150);
    this.shortenElementContent(subHeaderWrapper, 150);
  }

  setElementVisibility(visibility, element) {
    if (!(element instanceof HTMLElement)) return;
    if (visibility === 'show') {
      element.classList.remove('hidden');
      element.removeAttribute('aria-hidden');
    }
    if (visibility === 'hidden') {
      element.classList.add('hidden');
      element.setAttribute('aria-hidden', 'true');
    }
  }

  hideWelcomeBadges() {
    this.setElementVisibility('hidden', this.layoutElements.featureBadge);
  }

  hideHeader() {
    this.setElementVisibility('hidden', this.layoutElements.welcomeWrapper);
  }

  showHeader() {
    this.setElementVisibility('show', this.layoutElements.welcomeWrapper);
    if (this.layoutParams.formMode !== 'welcome') return;
    this.setElementVisibility('show', this.layoutElements.featureBadge);
  }

  shortenElementContent(element, characterLimit) {
    const content = element.textContent;
    if (content.length > characterLimit) {
      element.setAttribute('title', content);
      element.textContent = `${content.slice(0, characterLimit)}...`; // eslint-disable-line no-param-reassign
    }
  }

  onCalendarSelected(container, date) {
    const card = this.cards.find(p => p.cardContainer === container);
    this.datetimeHandler.onCalendarSelected(card, date);
  }

  onCalendarInit(calendar, container) {
    const id = container.split('-').slice(2).join('-');
    if (id.indexOf('-') > -1) {
      const jfcard = document.getElementById(`lite_mode_${id}`).closest('.jfCard');
      const card = this.cards.find(c => c.cardContainer === jfcard);
      this.datetimeHandler.onCalendarInit(card, calendar);
    } else {
      const card = this.cards.find(p => p.question.id === id);
      this.datetimeHandler.onCalendarInit(card, calendar);
    }
  }

  handleBackgroundVideo() {
    // IE11 cannot handle video and animations
    const { backgroundVideoPlayer: player } = this.layoutElements;
    const { browserName, browserVersion } = this.browserProperties;
    const isIE11 = browserName === 'Internet Explorer' && browserVersion === '11.0';
    if (isIE11 && player && player.pause && typeof player.pause === 'function') {
      player.pause();
    }
  }

  initBackgroundImageLoader() {
    const computedStyles = window.getComputedStyle(document.querySelector('.jfForm-backgroundContainer') || document.querySelector('.jfForm-wrapper'));
    const background = computedStyles ? computedStyles.getPropertyValue('background-image') : undefined;

    var removeNotLoaded = (() => {
      let isRemoved = false;
      return () => {
        if (!isRemoved) {
          removeClass(document.body, 'notLoaded');
          const isSmartEmbed = hasClass(document.body, 'isSmartEmbed');
          if (isSmartEmbed && this.cards.length) {
            const firstVisibleIndex = this.getFirstVisibleIndex();
            this.setCardIndex(firstVisibleIndex, false, true);
          }
          isRemoved = true;

          if (this.layoutParams.formMode === 'welcome') {
            this.calculateWelcomeSize();
          }
        }
      };
    })();

    if (background && background.indexOf('url(') > -1) {
      const url = background.split('"')[1];
      const image = new global.Image(0, 0);
      if (window && window.location.search === '?newForms=1') {
        const underlay = document.querySelector('.jfForm-backgroundUnderlay');
        if (underlay) {
          addClass(document.body, 'backgroundImageReady');
        }
      } else {
        setTimeout(() => {
          removeNotLoaded();
        }, 5000);
        const intervalID = setInterval(() => {
          if (image.complete) {
            // Remove image placeolder if defined
            const underlay = document.querySelector('.jfForm-backgroundUnderlay');
            if (underlay) {
              setTimeout(() => {
                addClass(document.body, 'backgroundImageReady');
              }, 125); // Magic number! (thanks safari <3)
            }
            removeNotLoaded();
            clearInterval(intervalID);
          }
        }, 500);
      }

      image.src = url;
    } else {
      removeNotLoaded();
    }
  }

  bindChangeEventForPressEnter() {
    // const setPressEnterVisibilty = (e) => {
    //   const formLine = closest(e.target, '.form-line');
    //   if (formLine) {
    //     const card = this.cards.find(p => p.formLine === formLine);
    //     if (card && card.question.type !== 'control_address' && (card.actionsButtons.mode === 'first' || card.actionsButtons.mode === 'middle') && this.validateCard(card, false, true)) {
    //       removeClass(card.pressEnterContainer, 'isHidden');
    //     } else {
    //       addClass(card.pressEnterContainer, 'isHidden');
    //     }
    //   }
    // };

    // bind events after calculation logic runs for the first time since it fires change event
    // setTimeout(() => {
    //   document.body.addEventListener('change', setPressEnterVisibilty);
    //   document.body.addEventListener('input', setPressEnterVisibilty);
    // }, 100);
  }

  bindChangeEventForNextButtons() {
    const updateNextButtonClasses = e => {
      const formLine = closest(e.target, '.form-line', 'body');
      if (formLine && formLine.getAttribute('data-type') !== 'control_address') {
        const card = this.cards.find(p => p.formLine === formLine);
        if (this.validateCard(card, false, true)) {
          const targetCard = closest(e.target, '.jfCard', 'body');
          const nextButton = targetCard.querySelector('.forNext');

          if (!hasClass(nextButton, 'animateNextButton')) {
            addClass(nextButton, 'animateNextButton');
          }
        }
      }
    };

    setTimeout(() => {
      document.body.addEventListener('change', updateNextButtonClasses);
      document.body.addEventListener('input', updateNextButtonClasses);
    }, 100);
  }

  getInputNamesAndValues() {
    const formData = document.forms[0].serialize().split('&').map(p => {
      return {
        name: decodeURIComponent(p.split('=')[0]),
        value: decodeURIComponent(p.split('=')[1])
      };
    });

    document.forms[0].querySelectorAll('.conditionallyDisabled').forEach(el => {
      formData.push({
        name: el.name,
        value: el.value
      });
    });

    this.cards.forEach(card => {
      const missingFields = ['control_radio', 'control_checkbox', 'control_imagechoice'].indexOf(card.question.type) !== -1;
      const markDownFields = ['control_textarea'].indexOf(card.question.type) !== -1;

      if (missingFields) {
        const inputs = card.cardContainer.querySelectorAll('input');
        let empty = true;
        forEach(inputs, input => {
          if (input.checked) { empty = false; }
          if (empty && input.hasAttribute('data-otherhint')) {
            const otherData = formData.find(other => other.name === input.name);

            if (otherData) {
              otherData.empty = true;
            }
          }
        });
        if (empty) { formData.push({ name: inputs[0].name, value: '', empty: true }); }
      }
      if (markDownFields) {
        const inputs = card.cardContainer.querySelectorAll('textarea');
        forEach(inputs, input => {
          const selectionQuery = card.markdownEditor ? `#${card.question.qid}_editor` : '*[class*="jfInput-textarea"]';
          const focusElement = card.cardContainer.querySelector(selectionQuery);
          if (focusElement) {
            const exactValue = card.markdownEditor != null ? focusElement.innerHTML : focusElement.value;
            formData.push({ name: input.name, value: exactValue, empty: true });
          }
        });
      }
    });

    return formData;
  }

  getFormData() {
    var translator = global.FormTranslation;

    const translate = text => {
      if (text) {
        const decoded = global.JotForm.decodeHtmlEntities(text).strip();
        return translator.translate(decoded);
      }
      return null;
    };

    const inputNamesAndValues = this.getInputNamesAndValues();
    const form = inputNamesAndValues.reduce((acc, { name, value, empty }) => {
      const regexTempFile = /temp_upload\[[^\]]+\]\[\]$/;

      if ((name.indexOf('_') > -1 && name.split('_')[0].indexOf('q') === 0) || regexTempFile.test(name)) {
        let element = document.forms[0][name];

        if (!element.tagName) { // means element is an array like
          forEach(element, elem => {
            if (elem.value === value) {
              element = elem;
            }
          });
        }

        if (!element.tagName) { // if no value match => not expected
          [element] = element;
        }

        const { id: elementId } = element;

        if (elementId.indexOf('addr_search') > -1) {
          return acc;
        }

        if (elementId.indexOf('fileUpload') > -1) {
          var jfCard = document.querySelectorAll('.jfCard');
          var id = elementId.match(/q(\d+)/)[1];

          jfCard.forEach(item => {
            if (item.parentNode.id.indexOf(`cid_${id}`) > -1) {
              item.appendChild(element);
            }
          });
        }

        const card = this.cards.find(p => p.cardContainer === closest(element, '.jfCard', 'body'));
        const existingCard = acc.find(p => p.card === card);

        // Translate element label
        if (card && translator && ('to' in translator)) {
          card.label = translate(card.label);
        }

        if (!existingCard) {
          acc.push({
            card, elements: [element], empty: empty
          });
        } else {
          existingCard.elements.push(element);
        }
      }
      return acc;
    }, []).map(p => {
      if (!p.card) {
        return undefined;
      }

      let multiSelectElements = null;
      const inputs = p.empty ? [] : p.elements.map(q => {
        // support for multiple select questions - included multi-line question
        if (q.type === 'select-multiple') {
          multiSelectElements = Array.from(q.querySelectorAll('option[selected]')).map(el => el.value).join(', ');
        } else {
          multiSelectElements = null;
        }
        return ({ element: q, name: q.name, value: multiSelectElements || q.value });
      });

      return {
        card: p.card,
        label: p.card ? p.card.label : '',
        valid: p.card && p.card.validate ? p.card.validate() : false,
        inputs
      };
    }).filter(p => typeof p !== 'undefined');
    // set custom markup for cards
    form.forEach(p => {
      p.customDraw = this.getCardReviewCustomDraw(p.card, p.inputs); // eslint-disable-line
    });

    // filter visible cards
    return form.filter(p => !p.card.isHidden);
  }

  getCardReviewCustomDraw(card, inputs) {
    if (card.type === Payment.paymentCards.products) {
      const wrapper = document.createElement('div');
      const div = document.createElement('div');
      const container = card.cardContainer;
      forEach(container.querySelectorAll('.product'), productRow => {
        const productSelection = Array.from(productRow.childNodes).find(c => c.tagName === 'INPUT');
        if (productSelection && productSelection.checked) {
          const pNameAndDetails = productRow.querySelector('.product__title');
          // Get product name from element without including it's children
          // User array's reduce method on array-like childNodes
          const pName = [].reduce.call(pNameAndDetails.childNodes, ((a, b) => { return a + (b.nodeType === 3 ? b.textContent : ''); }), '');
          // Get product details
          const pDetails = pNameAndDetails.querySelector('.jfField-product-description');
          const pSpan = document.createElement('span');
          pSpan.appendChild(global.document.createTextNode(`${pName}${pDetails && pDetails.textContent.length > 0 ? `, ${pDetails.textContent}` : ''},\u00A0`));
          div.appendChild(pSpan);
          const options = productRow.querySelectorAll('.jfProductOption');
          forEach(options, (option, index) => {
            const optionLabel = option.getAttribute('data-name');
            if (optionLabel) {
              const label = optionLabel;
              const optionValue = option.querySelector('select, input').value;

              const optionSpan = document.createElement('span');
              optionSpan.appendChild(global.document.createTextNode(`${label}: ${optionValue}${index < options.length - 1 ? ',' : ''}\u00A0`));
              div.appendChild(optionSpan);
            }
          });

          const table = productRow.querySelector('.jfSubProductTable');
          if (table) {
            const copy = table.cloneNode(true);
            forEach(copy.querySelectorAll('select, input'), input => {
              if (input.tagName !== 'SELECT' && (input.type === 'hidden' || input.style.display === 'none')) {
                input.parentNode.removeChild(input);
                return;
              }
              const { value } = input;
              if (value && value !== '0') {
                const parent = closest(input, 'td');
                map(parent.childNodes, p => p).forEach(p => { parent.removeChild(p); });
                parent.appendChild(global.document.createTextNode(value));
              } else {
                const tr = closest(input, 'tr');
                tr.parentNode.removeChild(tr);
              }
            });
            div.appendChild(copy);
          }

          wrapper.appendChild(div);
        }
      });
      if (container.querySelector('.donation-wrapper')) {
        const currency = card.cardContainer.querySelector('.js-donationCurrency');
        const amount = inputs && inputs[0] && inputs[0].value ? inputs[0].value : '';
        wrapper.appendChild(global.document.createTextNode(`${amount} ${currency && currency.textContent ? currency.textContent : ''}`));
      } else {
        const currencyLeft = card.cardContainer.querySelector('.currency__left');
        const total = global.document.getElementById('payment_footer_total');
        const currencyRight = card.cardContainer.querySelector('.currency__right');
        const currencyLeftTextContent = currencyLeft && currencyLeft.textContent ? currencyLeft.textContent : '';
        const currencyRightTextContent = currencyRight && currencyRight.textContent ? currencyRight.textContent : '';
        const totalTextContent = total && total.textContent ? total.textContent : '';

        const totalSpan = document.createElement('span');
        totalSpan.appendChild(global.document.createTextNode(`Total: ${currencyLeftTextContent}${totalTextContent}${currencyRightTextContent}`));
        wrapper.appendChild(totalSpan);
      }
      return wrapper;
    } else if (card.type === Payment.paymentCards.creditCard) {
      const creditCardWrapper = document.createElement('span');
      inputs.map(q => {
        const { value } = q;
        if (!q.value) return null;
        if (hasClass(q.element, 'cc_number')) return `************${value.substring(value.length - 4)}`;
        return value;
      })
        .filter(q => q)
        .forEach((answer, i) => {
          const answerSpan = document.createElement('span');
          const textNodeContent = `${answer}${i < inputs.length - 1 ? ',\u00A0' : ''}`;
          answerSpan.appendChild(global.document.createTextNode(textNodeContent));
          creditCardWrapper.appendChild(answerSpan);
        });
      return creditCardWrapper;
    } else if (card.question.type === 'control_imagechoice') {
      if (inputs && inputs.length) {
        const wrapper = document.createElement('div');
        inputs.forEach((input, i) => {
          const label = input.element.parentElement.querySelector('[class*=-labelText]').innerHTML;
          if (label) {
            const labelSpan = document.createElement('span');
            labelSpan.appendChild(global.document.createTextNode(`${label}${i < inputs.length - 1 ? ',\u00A0' : ''}`));
            wrapper.appendChild(labelSpan);
          }
        });
        return wrapper;
      }
    } else if (card.question.type === 'control_widget' && inputs) {
      const widgetData = inputs[0];
      if (widgetData) {
        const wrapper = document.createElement('div');
        try {
          const metadata = JSON.parse(widgetData.value);
          metadata.widget_metadata.value.forEach((value, i) => {
            if (value && value.name) {
              const labelSpan = document.createElement('span');
              labelSpan.appendChild(global.document.createTextNode(`${value.name}${i < metadata.widget_metadata.value.length - 1 ? ',\u00A0' : ''}`));
              wrapper.appendChild(labelSpan);
            }
          });
        } catch (ex) {
          const labelSpan = document.createElement('span');
          labelSpan.appendChild(global.document.createTextNode(widgetData.value));
          wrapper.appendChild(labelSpan);
        }
        return wrapper;
      }
    } else if (card.question.type === 'control_signature') {
      const wrapper = document.createElement('div');

      const image = new global.Image();
      image.src = inputs[0].value;
      wrapper.appendChild(image);
      return wrapper;
    } else if (card.question.type === 'control_matrix' && inputs) {
      const matrix = document.querySelector(`#matrix_${card.question.id}`);
      const dataType = matrix.getAttribute('data-type');
      if (dataType === 'Radio Button') {
        const translator = global.FormTranslation;
        const wrapper = document.createElement('div');
        const filteredInputs = inputs.filter(item => !(item.name.includes('rowIds') || item.name.includes('colIds')));
        filteredInputs.forEach((input, index) => {
          const value = translator && translator.translate ? translator.translate(input.value) : input.value;
          let label = '';
          if (this.layoutParams.deviceType === 'mobile') {
            const choiceWrapper = closest(input.element, '.jfMatrix-choiceWrapper');
            const dataVal = choiceWrapper.getAttribute('data-order');
            const cells = closest(input.element, '.jfMatrix').querySelectorAll('.jfMobileMatrix-question');
            const matrixCell = map(cells, p => p).filter(cell => cell.getAttribute('data-order') === dataVal);
            label = matrixCell && matrixCell[0] ? matrixCell[0].textContent : '';
          } else {
            const tableCells = closest(input.element, '.jfMatrixTable-row').querySelectorAll('.jfMatrixTable-cell');
            const valueCell = tableCells[0];
            label = valueCell.querySelector('.form-matrix-row-headers').querySelector('label').innerHTML;
          }
          wrapper.appendChild(global.document.createTextNode(`${label}: ${value}`));
          if (index < filteredInputs.length - 1) {
            wrapper.appendChild(document.createElement('br'));
          }
        });
        return wrapper;
      }
    } else if (card.question.type === 'control_datetime') {
      return this.createDatetimeReviewString(inputs);
    } else if (card.question.type === 'control_textarea' && card.markdownEditor && card.markdownEditor.editorContainer) {
      const textareaWrapper = global.document.createElement('span');
      const { childNodes } = card.markdownEditor.editorContainer;
      forEach(childNodes, node => {
        const cloneNode = node.cloneNode(true);
        textareaWrapper.appendChild(cloneNode);
      });
      return textareaWrapper;
    } else if (card.question.type === 'control_time') {
      const timeFormat = inputs.find(input => {
        return input.name.indexOf('ampm') > -1;
      });
      const wrapper = document.createElement('div');
      inputs.forEach((input, i) => {
        if (input && input.value) {
          const labelSpan = document.createElement('span');
          let sign = '';
          if (i < inputs.length - 1) {
            if (timeFormat !== undefined) { // if the time format is AM/PM
              sign = input.name.indexOf('[ampm]') > -1 ? ',\u00A0' : ':';
              if (inputs[i + 1] && inputs[i + 1].name.indexOf('ampm') > -1) { sign = '\u00A0'; }
            } else {
              sign = inputs[i + 1] && inputs[i + 1].name.indexOf('hourSelectRange') > -1 ? ',\u00A0' : ':';
            }
            if (inputs[i + 1] && inputs[i + 1].name.indexOf('timeRangeDuration') > -1) { sign = '\u00A0:'; }
          }
          labelSpan.appendChild(global.document.createTextNode(`${input.value}${sign}`));
          wrapper.appendChild(labelSpan);
        }
      });
      return wrapper;
    } else if (card.question.type === 'control_mixed') {
      const wrapper = document.createElement('div');
      const labelSpan = document.createElement('span');
      const inputValues = inputs.filter(input => {
        return (input && input.value && input.value !== '');
      });
      inputValues.forEach((input, i) => {
        labelSpan.appendChild(global.document.createTextNode(`${input.value}${i < inputValues.length - 1 ? ',\u00A0' : ''} `));
        wrapper.appendChild(labelSpan);
      });
      return wrapper;
    } else if (card.question.type === 'control_inline') {
      // detect signatures for custom draw
      const customDraws = {};
      inputs.forEach((input, i) => {
        if (input.value.indexOf('data:image/png;base64') === 0) {
          const wrapper = document.createElement('span');
          const image = new global.Image();
          image.src = input.value;
          wrapper.appendChild(image);
          customDraws[i] = wrapper;
        }
      });
      return customDraws;
    }
  }

  createDatetimeReviewString(inputs) {
    // Get year, month, day, hour, min and ampm format
    const values = {
      year: '',
      month: '',
      day: '',
      hour: '',
      min: '',
      ampm: '',
      datetimeString: ''
    };
    const indexes = {
      year: false,
      month: false,
      day: false
    };
    Object.keys(values).forEach(key => {
      const index = inputs.findIndex(input => input.name.indexOf(`[${key}]`) > -1);
      if (key in indexes) {
        indexes[key] = index;
      }
      values[key] = index !== -1 ? inputs[index].value : '';
    });
    const findLocaleDelimiter = str => {
      if (!str) return '/';
      for (let i = 0; i < str.length; i++) {
        if (!/^[0-9a-zA-Z\s]+$/.test(str[i])) {
          return str[i];
        }
      }
      return '/';
    };
    // Create string
    let datetime = new Date();
    if (values.year && values.month && values.day) {
      datetime = new Date(values.year, values.month - 1, values.day);
      const datetimeString = datetime.toLocaleDateString(undefined, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
      const delimiter = findLocaleDelimiter(datetimeString);
      const sortedValues = Object.keys(indexes).sort((a, b) => indexes[a] - indexes[b]);
      values.datetimeString = sortedValues.reduce((prev, cur) => {
        return `${prev}${delimiter}${values[cur]}`;
      }, '').substr(1) || datetimeString;
    }
    if (values.hour && values.min) {
      if (values.ampm === 'AM') {
        if (values.hour === '12') values.hour = '0';
      } else if (values.ampm === 'PM') {
        if (values.hour !== '12') values.hour = parseInt(values.hour, 10) + 12;
      }
      datetime.setHours(values.hour);
      datetime.setMinutes(values.min);
      values.datetimeString = `${values.datetimeString} ${datetime.toLocaleTimeString(undefined, {
        hour: '2-digit',
        minute: '2-digit'
      })}`;
    }
    // Append our string into container
    const dateTimeTextNode = global.document.createTextNode(values.datetimeString);
    const dateTimeSpan = document.createElement('span').appendChild(dateTimeTextNode);
    return dateTimeSpan;
  }

  adjustAppointmentDate(values) {
    const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const DAYS_OF_WEEK = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    const duration = values[2] || 0;
    const stringToDate = values[1].replaceAll('-', '/');
    const date = new Date(stringToDate);
    const endDate = new Date();
    endDate.setTime(date.getTime() + (Number(duration) * 60000));

    return `${DAYS_OF_WEEK[date.getDay()].locale()}, ${MONTHS[date.getMonth()].locale().substring(0, 3)} ${this.padStart2(date.getDate())}, ${date
      .getFullYear()} ${this.padStart2(date.getHours())}:${this.padStart2(date.getMinutes())} - ${this
      .padStart2(endDate.getHours())}:${this.padStart2(endDate.getMinutes())}, ${values[3]}`;
  }

  padStart2(element) {
    return String(element).padStart(2, '0');
  }

  prepareReviewMarkup(form) {
    const itemTemplate = global.document.querySelector('#reviewBeforeSubmit .js-reviewItemTemplate');
    const translator = global.FormTranslation;
    const lines = form.map(p => {
      const markup = itemTemplate.cloneNode(true);
      markup.style.display = 'block';
      const cardOrder = this.cards.filter(c => !c.isHidden).indexOf(p.card) + 1;
      const labelContainer = markup.querySelector('.js-reviewItemTitle');
      const indexContainer = markup.querySelector('.js-reviewItemIndex');
      const answersContainer = markup.querySelector('.js-reviewItemAnswer');
      const editLink = markup.querySelector('.js-reviewItemEditLink');
      editLink.addEventListener('click', () => { this.showFormPreview(false, this.cards.indexOf(p.card)); });

      if (!p.valid) {
        const titleContainer = markup.querySelector('.jfReviewItem-header');
        addClass(titleContainer, 'hasError');
      }

      // get placeholder values for review card and replace accordingly.
      var matches = p.label ? p.label.match(/([^{]*?)\w(?=\})/gmi) : null;
      if (matches) {
        let resultLabel = p.label;
        matches.forEach(match => {
          let element;
          for (let i = 0; i < this.cards.length; i++) {
            const card = this.cards[i];
            element = card.cardContainer.querySelector(`span[class*="_${match}"]`);
            if (element) {
              break;
            }
          }
          if (element && element.innerHTML !== '') {
            var rgx = new RegExp(`{${match}}`, 'g');
            resultLabel = resultLabel.replace(rgx, element.innerHTML);
          }
        });
        labelContainer.appendChild(global.document.createTextNode(resultLabel));
      } else {
        labelContainer.appendChild(global.document.createTextNode(p.label));
      }

      indexContainer.appendChild(global.document.createTextNode(cardOrder));
      if (p.customDraw) {
        if (p.card.question.type === 'control_imagechoice') {
          const imageChoiceContainer = document.createElement('div');
          imageChoiceContainer.className = 'imageChoiceContainer';
          const values = p.inputs.map(q => q.value.split('|'));
          values.forEach((element, i) => {
            const imageChoiceContent = document.createElement('div');
            imageChoiceContent.className = 'imageChoiceContent';
            const answerContent = document.createElement('div');
            const answerImage = document.createElement('img');
            answerImage.src = element[1].length > 0 ? element[1] : 'data:,';
            answerImage.alt = element[1].length > 0 ? element[1] : 'data:,';
            answerContent.textContent = `${element[0]}${(element[0].length === 0 || i === values.length - 1) ? '\u00A0' : ',\u00A0'}`;
            imageChoiceContent.appendChild(answerImage);
            imageChoiceContent.appendChild(answerContent);
            imageChoiceContainer.appendChild(imageChoiceContent);
            answersContainer.appendChild(imageChoiceContainer);
          });
        } else if (p.card.question.type === 'control_widget') {
          if (p.card.cardContainer.querySelectorAll('[data-widget-id="529c8286a75dae5e7f000005"]').length > 0 && p.inputs[0].value.length > 0) {
            // Take Photo Widget
            const takePhotoContainer = document.createElement('div');
            takePhotoContainer.className = 'imageChoiceContainer';
            const { value } = p.inputs[0];
            const takePhotoContent = document.createElement('div');
            takePhotoContent.className = 'imageChoiceContent';
            const answerImage = document.createElement('img');
            answerImage.src = value;
            answerImage.alt = value;
            takePhotoContent.appendChild(answerImage);
            takePhotoContainer.appendChild(takePhotoContent);
            answersContainer.appendChild(takePhotoContainer);
          } else if (p.card.cardContainer.querySelectorAll('[data-widget-id="533946093c1ad0c45d000070"]').length > 0 && p.inputs[0].value.length > 0) {
            const { value } = p.inputs[0];
            if (this.isJsonString(value)) {
              const jsonData = value.replace(/"([^"]+)":/g, '"$1 ":');
              const elements = JSON.parse(jsonData);
              const table = document.createElement('table');
              table.className = 'table-grid';
              table.style.cssText = 'border:0;cellpadding:5;cellspacing:0;width:100%';

              const tbody = document.createElement('tbody');
              tbody.className = 'table-body';
              let setHeader = true;
              elements.forEach(valueElement => {
                if (setHeader) {
                  const headerTr = document.createElement('tr');
                  headerTr.className = 'table-row';
                  /* eslint-disable no-restricted-syntax */
                  for (const key in valueElement) {
                    const thead = document.createElement('th');
                    thead.className = 'table-head';
                    thead.textContent = key;
                    headerTr.appendChild(thead);
                  }
                  /* eslint-enable no-restricted-syntax */
                  tbody.appendChild(headerTr);
                }
                const tr = document.createElement('tr');
                /* eslint-disable no-restricted-syntax */
                for (const key in valueElement) {
                  const td = document.createElement('td');
                  td.className = 'table-col';
                  td.textContent = valueElement[key];
                  tr.appendChild(td);
                }
                /* eslint-enable no-restricted-syntax */
                tbody.appendChild(tr);
                setHeader = false;
              });
              table.appendChild(tbody);
              answersContainer.appendChild(table);
            } else {
              answersContainer.appendChild(p.customDraw);
            }
          } else {
            answersContainer.appendChild(p.customDraw);
          }
        } else if (p.card.question.type === 'control_inline') {
          const values = p.inputs.map(q => q.value);
          values.forEach((answer, i) => {
            if (p.customDraw[i]) {
              answersContainer.appendChild(p.customDraw[i]);
            } else if (answer !== '') {
              const answerSpan = document.createElement('span');
              const textNodeContent = `${answer}${i < values.length - 1 ? ',\u00A0' : ''}`;
              answerSpan.appendChild(global.document.createTextNode(textNodeContent));
              answersContainer.appendChild(answerSpan);
            }
          });
        } else {
          answersContainer.appendChild(p.customDraw);
        }
      } else {
        let values = p.inputs.map(q => q.value);
        if (p.card.question.type === 'control_appointment' && values[1] && values[3]) {
          values = [this.adjustAppointmentDate(values)];
        }
        const uniqueValues = values.filter((el, i) => {
          return (el && values.indexOf(el) === i);
        });
        uniqueValues.forEach((answer, i) => {
          const answerSpan = document.createElement('span');
          // only translate answers with options
          let val = answer;
          const fieldsToTranslate = ['control_dropdown', 'control_yesno', 'control_radio', 'control_checkbox', 'control_matrix'];
          if (translator && translator.translate && fieldsToTranslate.include(p.card.question.type)) {
            val = translator.translate(answer);
          }
          let textNodeContent;
          if (p.card.question.type === 'control_fullname') {
            textNodeContent = `${val}${i < uniqueValues.length - 1 ? '\u00A0' : ''}`;
          } else if (p.card.question.type === 'control_fileupload') {
            const file = document.querySelector(`.qq-upload-list li:nth-child(${i + 1})`);
            const size = file.querySelector('.qq-upload-size').textContent;
            answerSpan.style.display = 'block';
            textNodeContent = `${val} (${size})`;
          } else {
            textNodeContent = `${val}${i < uniqueValues.length - 1 ? ',\u00A0' : ''}`;
          }
          answerSpan.appendChild(global.document.createTextNode(textNodeContent));
          answersContainer.appendChild(answerSpan);
        });
      }
      return markup;
    });
    const container = global.document.createElement('div');
    container.className = 'js-reviewItemsContainer';
    lines.sort((first, second) => {
      const firstVal = first.querySelector('.js-reviewItemIndex').textContent / 1;
      const secondVal = second.querySelector('.js-reviewItemIndex').textContent / 1;
      if (firstVal > secondVal) {
        return 1;
      }
      if (firstVal < secondVal) {
        return -1;
      }
      return 0;
    });
    lines.forEach(p => { container.appendChild(p); });

    return container;
  }

  showFormPreview(show, questionIndex) {
    const reviewContainer = global.document.getElementById('reviewBeforeSubmit');
    const listContainer = reviewContainer.querySelector('.js-reviewItemList');
    if (show) {
      const old = reviewContainer.querySelector('.js-reviewItemsContainer');
      if (old) {
        old.parentNode.removeChild(old);
      }
      this.updateCardLabels();
      const items = this.prepareReviewMarkup(this.getFormData());
      listContainer.appendChild(items);
      this.setFormMode('review');
    } else {
      setTimeout(() => {
        if (typeof questionIndex === 'number') {
          this.setCardIndex(questionIndex, true);
        }
        this.setFormMode('form', false, true);
      }, 0);
    }
  }

  replaceSubmitWithReviewAndSubmit() {
    const cloneDesktopSubmitButton = this.cards[0].actionsButtons.submit.cloneNode(true);
    const invisibleSubmitButton = this.cards[0].actionsButtons.submit.cloneNode(true);
    const { mobileSubmitButton, mobileNavigationWrapper } = this.layoutElements;
    const cloneMobileSubmit = mobileSubmitButton.cloneNode(true);

    invisibleSubmitButton.style.display = 'none';
    invisibleSubmitButton.style.position = 'absolute';
    document.forms[0].appendChild(invisibleSubmitButton);

    cloneDesktopSubmitButton.removeAttribute('style');
    addClass(cloneDesktopSubmitButton, 'form-submit-button');
    const { reviewText, backText } = this.layoutParams.reviewBeforeSubmit;
    const overrideSubmitButton = btn => {
      btn.textContent = reviewText; // eslint-disable-line
      btn.type = 'button'; // eslint-disable-line
      removeClass(btn, 'form-submit-button');
      removeClass(btn, 'forSubmit');
      removeClass(btn, 'jsMobileSubmit');
      addClass(btn, 'forReviewButton');
      addClass(btn, 'forReview');
    };
    this.cards.forEach(card => {
      overrideSubmitButton(card.actionsButtons.submit);
    });

    overrideSubmitButton(this.layoutElements.mobileSubmitButton);
    const cloneSubmitButtons = [cloneDesktopSubmitButton, cloneMobileSubmit];
    // bind submit events
    forEach(cloneSubmitButtons, btn => btn.addEventListener('click', () => {
      invisibleSubmitButton.click();
    }));

    const submitButtonInReview = global.document.querySelector('#reviewBeforeSubmit .forReviewButton');
    const backToFormButtons = global.document.querySelectorAll('#reviewBeforeSubmit .forBackToForm, .jsMobileNavigation .forBackToForm');
    const useJFSignButton = global.document.querySelector('.useJotformSign-button');

    forEach(backToFormButtons, reviewButton => {
      if (reviewButton) {
        reviewButton.textContent = backText; // eslint-disable-line
        reviewButton.addEventListener('click', () => {
          this.showFormPreview(false);
        });
      }
    });
    // selected JF sign button needs to be visible
    if (global.useJotformSign === 'Yes' && useJFSignButton) {
      useJFSignButton.style.display = 'block';
    }

    // for desktop
    submitButtonInReview.parentNode.replaceChild(
      // when JF sign automation enabled, custom sign button needs to be replaced instead of normal submit button
      (global.useJotformSign === 'Yes' && useJFSignButton)
        ? useJFSignButton
        : cloneDesktopSubmitButton, submitButtonInReview
    );

    global.document.addEventListener('click', e => {
      if (closest(e.target, '.forReviewButton')) {
        if (global.JotForm.validateAll()) {
          if (global.JotForm.disableSubmitButton) {
            global.JotForm.toggleDisableSubmitMessage();
          } else {
            const { currentCardIndex, cardMode } = this.layoutParams;
            if (currentCardIndex > -1) {
            // added an additional check for review and submit
            // check current card validate for error statements
              if (cardMode === 'scroll' || this.validateCard(this.cards[currentCardIndex])) {
                this.showFormPreview(true);
                // custom sign button(useJotformSign-button) needs to be excluded from form submit buttons
                const isSubmitExists = mobileNavigationWrapper && mobileNavigationWrapper.querySelector('.form-submit-button:not(.useJotformSign-button)');
                if (!isSubmitExists) { // for mobile
                  mobileNavigationWrapper.appendChild(cloneMobileSubmit);
                  // button actions are re-run because of the clone operation
                  global.JotForm.setButtonActions();
                }
              } else {
                this.shakeCard(currentCardIndex);
                this.focusToFirstError(currentCardIndex);
              }
            }
          }
        }
      }
    });
  }

  getTotalWelcome() {
    const welcomeRect = document.getElementById('header_welcomePage') ? document.getElementById('header_welcomePage').getBoundingClientRect() : { height: 0 };
    const welcomeSubRect = document.getElementById('subHeader_welcomePage') ? document.getElementById('subHeader_welcomePage').getBoundingClientRect() : { height: 0 };
    return welcomeSubRect.height > (welcomeRect.height * 2.9) ? (welcomeRect.height * 3.9) : welcomeRect.height + welcomeSubRect.height;
  }

  calculateAvailableHeightForFields(nextCardIndex = null) {
    if (!this.cards || !this.cards[0]) return;
    // const cardScale = _cardScale || this.layoutParams.formMode === 'form' ? 1 : 100;

    // const { smartEmbedMaxHeight, deviceType } = this.layoutParams;
    const isSmartEmbed = hasClass(document.body, 'isSmartEmbed');

    const totalWelcome = this.getTotalWelcome();
    const progressRect = document.getElementById('cardProgress').getBoundingClientRect();
    const footerHeight = document.querySelector('.formFooter') ? document.querySelector('.formFooter').getBoundingClientRect().height : 0;
    const windowHeight = window.innerHeight;
    const welcomeTopMargin = windowHeight * 0.05;
    // const computedStyles = window.getComputedStyle(this.cards[0].cardContainer);
    // const currentCardFontSizePx = computedStyles ? +computedStyles.fontSize.slice(0, -2) : 16;
    // const cardQuestionPaddingTopAndBottom = currentCardFontSizePx * 2.2;
    const paddingBottom = this.layoutParams.deviceType === 'mobile' ? 80 : 54;
    let bottomPaddingTotal = this.layoutParams.resolutionType === 'mobile' ? (paddingBottom + footerHeight) : (progressRect.height + footerHeight); // it has fixed height in mobile view
    // if progress is not visible on form, give a little space to bottom
    bottomPaddingTotal = bottomPaddingTotal === 0 ? welcomeTopMargin : bottomPaddingTotal;
    // const maxOfWelcomeAndProgress = Math.max(welcomeTopMargin + totalWelcome, progressRect.height) * 2;
    // const welcomeAndBottomSide = isSmartEmbed ? 0 : (welcomeTopMargin + totalWelcome + bottomPaddingTotal);
    // const additionalMargin = 4.2 * currentCardFontSizePx; // previously 2.5 but it was a little bit tight
    // const actionHeight = (3.5 * currentCardFontSizePx) + 2;

    // const total = actionHeight + cardQuestionPaddingTopAndBottom + welcomeAndBottomSide + additionalMargin;
    // const total = actionHeight + welcomeAndBottomSide + additionalMargin;

    if (this.layoutParams.formMode === 'form') {
      document.querySelector('.jfForm-wrapper').style.paddingBottom = `${isSmartEmbed ? 0 : bottomPaddingTotal}px`;
      document.querySelector('.jfForm-wrapper').style.paddingTop = `${isSmartEmbed ? 0 : (welcomeTopMargin + totalWelcome + (this.layoutParams.deviceType === 'mobile' ? -15 : 0))}px`;
    }

    if (this.layoutParams.deviceType === 'mobile') {
      this.cards.forEach(card => {
        if (card.label) {
          const label = card.cardContainer.querySelector('.jfQuestion-label');
          const charLimits = [0, 100, 200, 300, 400];
          const classList = ['p1', 'p2', 'p3', 'p4', 'p5'];
          let index = 0;
          while (card.label.length >= charLimits[index]) {
            index++;
          }
          index = index === 0 ? 0 : index - 1;
          if (label) {
            addClass(label, `${classList[index]}`);
          }
        }
      });
    }

    this.calculateCardsHeight(nextCardIndex);

    this.handleFullScreenToggle();
  }

  onFileUploadChanged(id) {
    const card = this.cards.find(p => p.question.id === id);
    if (card) {
      const fileList = card.cardContainer.querySelectorAll('.qq-upload-list li');
      card.isFilled = fileList.length > 0;
    }
  }

  fillInitialValuesForEditMode(card) {
    if (card.question.type === 'control_datetime') {
      const qid = card.question.id;
      const day = card.cardContainer.querySelector(`#day_${qid}`);
      const month = card.cardContainer.querySelector(`#month_${qid}`);
      const year = card.cardContainer.querySelector(`#year_${qid}`);

      if (day.value && month.value && year.value) {
        const dateInput = card.cardContainer.querySelector('.jfCardDateInput');
        dateInput.value = `${year.value}-${month.value}-${day.value}`;
      }
    } else if (card.question.type === 'control_rating') {
      const items = map(card.cardContainer.querySelectorAll('.jfRating-item.jfRating-selection'), p => p);
      const checkedIndex = items.findIndex(p => p.querySelector('input').checked === true);

      if (checkedIndex > -1) {
        for (let i = 0; i <= checkedIndex; i++) {
          addClass(items[i], 'checked');
        }
        // #1749513: add the selected rating value to hidden input of rating stars
        const starsInput = document.querySelector(`input[name="q${card.question.id}_stars"]`);
        starsInput.value = checkedIndex + parseInt(starsInput.dataset.lowest, 10);
      }
    }
  }

  // Returns if index is visible or not.
  isVisibleIndex(index) {
    const card = this.cards[index];
    return card && !card.isHidden;
  }

  // Returns first visible card index.
  getFirstVisibleIndex(type = null) {
    if (type) {
      return this.cards.findIndex(p => !p.isHidden && p.question.type === type);
    }
    return this.cards.findIndex(p => !p.isHidden);
  }

  getLastVisibleIndex() {
    let lastVisibleIndex = 0;
    for (let i = this.cards.length - 1; i >= 0; i--) {
      if (!this.cards[i].isHidden) {
        lastVisibleIndex = i;
        break;
      }
    }
    return lastVisibleIndex;
  }

  // Extract id from url (#id) (not index! it is id, so if you need index you need to  do -1)
  getQuestionIdFromUrlHash(url) {
    const match = url.match(/#([0-9]+)/);
    return (match ? match[1] : false);
  }

  // Listen question changes
  onLocationHashChange() {
    const url = global.location.href || '';
    const newQuestionId = this.getQuestionIdFromUrlHash(url);
    const newQuestionIndex = newQuestionId ? parseInt(newQuestionId, 10) - 1 : 0;
    const isQuestionChanged = newQuestionIndex !== this.layoutParams.currentCardIndex;

    // Do nothing if question is not changed.
    if (!isQuestionChanged) { return; }

    // Go to question if it is visible
    if (this.isVisibleIndex(newQuestionIndex)) {
      this.setCardIndex(newQuestionIndex);
      return;
    }

    // otherwise go to first question :) hehe.
    const firstVisibleIndex = this.getFirstVisibleIndex();
    this.setCardIndex(firstVisibleIndex);
  }

  setDropdownInitialValues() {
    this.dropdown.setInitialValues();
  }

  onFormTranslated() {
    translateDefaultCardFormTexts();
    translateComponentFields(this.cards);
    this.translateSectionHeader();
    this.translateListOfQuestionsItems();
    setTimeout(() => this.updateMatrixLayout(), 25);
  }

  translateListOfQuestionsItems() {
    const listOfQuestionItems = document.getElementsByClassName('jfProgress-itemWrapper')[0].children;
    let index = 0;
    Array.from(listOfQuestionItems).forEach(question => {
      const label = question.querySelector('.jfProgress-itemLabel');
      const labelTextWithoutQNumber = label.innerText.replace(`${index + 1}. `, '');
      if (labelTextWithoutQNumber === `Question ${index + 1}`) {
        const translator = global.FormTranslation;
        const { cardTexts } = translator;
        const currentLang = translator.to;
        const translateText = '{number} Question';
        if (cardTexts && currentLang && cardTexts[currentLang] && cardTexts[currentLang][translateText]) {
          const questionTitle = cardTexts[currentLang][translateText];
          label.innerText = questionTitle.replace('{number}', `${index + 1}.`);
        }
      }
      index++;
    });
  }

  translateSectionHeader() {
    const translator = global.FormTranslation;

    if (translator) {
      const sectionHeader = this.currentHeader;
      const translate = text => {
        if (text) {
          const decoded = global.JotForm.decodeHtmlEntities(text).strip();
          return translator.translate(decoded);
        }
        return null;
      };

      const {
        welcomeHeaderContainer,
        welcomeSubHeaderContainer,
        welcomeSectionInfoText,
        welcomeSectionInfoQuestionCount
      } = this.layoutElements;

      const headerTranslation = translate(sectionHeader.props.text.value);
      if (headerTranslation) welcomeHeaderContainer.innerHTML = headerTranslation;

      const subHeaderTranslation = translate(sectionHeader.props.subHeader.value);
      if (subHeaderTranslation) welcomeSubHeaderContainer.innerHTML = subHeaderTranslation;

      if (sectionHeader.props.showQuestionCount && sectionHeader.props.showQuestionCount.value === 'Yes') {
        let sectionText = welcomeSectionInfoText.innerHTML;
        const { cardTexts } = translator;
        const currentLang = translator.to;
        if (cardTexts && currentLang && cardTexts[currentLang] && sectionText) {
          let sectionInfoText = '{number} Question';
          if (parseInt(welcomeSectionInfoQuestionCount.innerHTML, 10) > 1) {
            sectionInfoText = '{number} Questions';
          }
          if (cardTexts[currentLang][sectionInfoText]) {
            sectionText = cardTexts[currentLang][sectionInfoText];
            welcomeSectionInfoText.innerHTML = sectionText.replace(/{number}\s?/, '');
          } else {
            welcomeSectionInfoText.innerHTML = cardTexts[currentLang][sectionText] ? cardTexts[currentLang][sectionText] : sectionText;
          }
        }
      }

      let nextButtonText = 'Next';

      if (sectionHeader === this.welcomePageProps && sectionHeader.props.buttonText && sectionHeader.props.buttonText.value) {
        nextButtonText = sectionHeader.props.buttonText.value;
      } else if (sectionHeader.props.nextButtonText && sectionHeader.props.nextButtonText.value) {
        nextButtonText = sectionHeader.props.nextButtonText.value;
      }

      const previousButtonText = sectionHeader.props.previousButtonText && sectionHeader.props.previousButtonText.value ? sectionHeader.props.previousButtonText.value : 'Previous';

      const nextButtonTranslation = translate(nextButtonText);
      if (nextButtonTranslation) this.layoutElements.startButton.innerHTML = nextButtonTranslation;

      const prevButtonTranslation = translate(previousButtonText);
      if (prevButtonTranslation) this.layoutElements.previousButton.innerHTML = prevButtonTranslation;
    }
  }

  setInitialSelectionForMatrixSliders(id) {
    const matrixQuestion = this.cards.find((q) => q.question.id == id).question; // eslint-disable-line
    const hasMatrixSliders = (matrixQuestion && matrixQuestion.componentClass && matrixQuestion.componentClass.sliders && matrixQuestion.componentClass.sliders.length > 0) ? true : false;
    if (hasMatrixSliders) {
      matrixQuestion.componentClass.sliders.forEach(item => {
        item.slider.makeInitialSelection();
      });
    }
  }

  updateMatrixLayout() {
    this.layoutParams.questions.forEach(q => {
      if (q.type === 'control_matrix') {
        global.JotForm.setMatrixLayout(q.id);
      }
    });
  }

  clearAddressFields() {
    const cleanClass = 'jfAddress-clean';
    const cleanAddressFields = global.document.getElementsByClassName(cleanClass);

    forEach(cleanAddressFields, field => removeClass(field, cleanClass));
  }

  recalculateCurrentCardHeight() {
    this.calculateCardHeight(this.getCurrentCard());
  }

  calculateWelcomeSize() {
    const { formMode } = this.layoutParams;
    const { welcomeContainer, welcomeCardBackground } = this.layoutElements;

    if (!formMode || formMode === 'form') return;
    if (!welcomeContainer || !welcomeCardBackground) return;

    setTimeout(() => {
      const { offsetWidth, offsetHeight } = welcomeContainer;
      welcomeCardBackground.style.width = `${offsetWidth}px`;
      welcomeCardBackground.style.height = `${offsetHeight}px`;
    }, 50);
  }

  calculateInitialCardHeight() {
    this.calculateCardHeight(this.cards[0]);
  }

  calculateCardsHeight(nextCardIndex) {
    const forced = global.location.href.indexOf('forceCardHeightCalc=true') >= 0;
    if (!forced && this.layoutParams.deviceType === 'mobile') return;
    if (!forced && this.isFeedbackEmbedButton) return;

    if (nextCardIndex === null) {
      // Note: Going thru all the questions was causing huge performance issues
      // as the question count increases. For 512 questions performance sample
      // count dropped from 14,000~ to an average of 400~, please only whitelist
      // the questions that might render more content after it's loaded or it's
      // own card UI might change at some point for some reason.
      //
      // Fixes #4447305
      const whitelistedQuestionTypes = [
        'control_appointment',
        'control_payment'
      ];

      this.cards.filter(card => whitelistedQuestionTypes.includes(card.question.type)).forEach(this.calculateCardHeight);
    } else {
      this.calculateCardHeight(this.cards[nextCardIndex]);
    }
  }

  calculateAllCardsHeight() {
    this.cards.forEach(this.calculateCardHeight);
  }

  calculateCardHeight(c) {
    const card = c;

    let maxCardHeight = this.layoutElements.formWrapper.clientHeight;

    const getFontSize = el => parseInt(window.getComputedStyle(el).fontSize.replace('px', ''), 10);
    const decreaseLabelFontSize = elem => {
      const el = elem;
      el.style.fontSize = `${getFontSize(el) - 2}px`;
    };

    const resetScroll = elem => {
      const el = elem;
      el.style.maxHeight = 'unset';
      el.style.overflowY = 'unset';
    };

    const cardHasScroll = el => el.questionContainer.scrollHeight > el.questionContainer.clientHeight;

    const isLabelSingleLine = l => {
      const labelLineHeight = parseInt(window.getComputedStyle(l).lineHeight.replace('px', ''), 10);
      return l.clientHeight <= labelLineHeight;
    };

    const label = card.cardContainer.querySelector('.jfQuestion-label');
    const desc = card.cardContainer.querySelector('.jfQuestion-description');

    let actionButtonWrapperHeight = card.actionButtonsWrapper !== null && card.actionButtonsWrapper.getBoundingClientRect().height;
    const submitError = card.cardContainer.querySelector('.form-button-error');

    if (this.layoutParams.cardMode === 'scroll') {
      actionButtonWrapperHeight /= this.layoutParams.cardScrollScale;
    }

    if (card.hasSubmit && submitError) {
      maxCardHeight = maxCardHeight - submitError.getBoundingClientRect().height;
    }

    if (!hasClass(document.body, 'forMiniCard')) {
      maxCardHeight = maxCardHeight - this.getTotalWelcome();
    }

    card.cardContainer.style.maxHeight = `${maxCardHeight}px`;
    card.questionContainer.style.maxHeight = `${maxCardHeight - actionButtonWrapperHeight}px`;

    if (card.question.type !== 'control_address') {
      card.questionContainer.style.overflowY = 'auto';
    }

    if (window && window.formUserHeader === true) {
      card.questionContainer.style.maxHeight = `${maxCardHeight - actionButtonWrapperHeight - 140}px`;
    }

    if (label) {
      resetScroll(label);
      label.setAttribute('tabindex', 0);
    }

    if (desc) desc.setAttribute('tabindex', 0);

    if (cardHasScroll(card)) {
      const description = card.cardContainer.querySelector('.jfQuestion-description');

      if (label || description) {
        let labelFontSize = 0;
        let descFontSize = 0;

        if (label) labelFontSize = getFontSize(label);

        if (description) descFontSize = getFontSize(description);

        let i = 0;
        // The smallest mobile screen width is 320px
        while (cardHasScroll(card) && ((!isLabelSingleLine(label) && labelFontSize > this.minLabelFontSize) || descFontSize > this.minDescFontSize) && label.clientWidth > 320) {
          if (label && labelFontSize > this.minLabelFontSize) {
            if (!isLabelSingleLine(label)) decreaseLabelFontSize(label);
            labelFontSize = getFontSize(label);
          }

          if (description && descFontSize > this.minDescFontSize) {
            decreaseLabelFontSize(description);
            descFontSize = getFontSize(description);
          }

          i++;
          // shit happens
          if (i > 10) break;
        }
      }
    }

    this.datetimeHandler.updateCalendarPositions();

    if (card.type === 'products' && this.getCurrentCard().type === card.type) {
      this.calculateProductsPerPage();
    }
  }

  setLanguageDropdownVisibility(firstVisibleCardIndex, currentCardIndex) {
    const langDropdown = document.querySelector('#langDd');
    if (!langDropdown) return;

    if (currentCardIndex > firstVisibleCardIndex) {
      langDropdown.classList.add('firstPageOnly');
    } else {
      langDropdown.classList.remove('firstPageOnly');
    }
  }

  handleWidgetsVisibility(visibleCard) {
    // get the widget on the current visible card
    const { id, type } = visibleCard.question;
    if (type === 'control_widget') {
      global.JotForm.showWidget(id);
    }
  }

  checkConditionOnCurrentCard() {
    if (global.JotForm.conditions.length !== undefined) {
      const currentCard = this.getCurrentCard();
      const questionID = currentCard && currentCard.question && currentCard.question.id;
      global.JotForm.conditions.forEach(condition => {
        let isConditionRelatedWithCurrentField = true;
        if (questionID) {
          isConditionRelatedWithCurrentField = Array.isArray(condition.terms) && condition.terms.some(term => {
            // check for the multi-line question type
            if (term.field && term.field.indexOf('|') > -1) {
              return term.field.split('|')[0] === questionID.toString();
            }
            return term.field === questionID.toString();
          });
        }

        if (!condition.disabled && isConditionRelatedWithCurrentField) {
          global.JotForm.checkCondition(condition);
        }
      });
    }
  }

  onSCLStateChange(newState) {
    const stateElement = document.querySelector('.jf-saclState');
    const progressSacl = document.querySelector('.jfProgress-sacl');
    if (!stateElement || !progressSacl) {
      return;
    }

    let icon;
    let text;

    switch (newState) {
      case this.saveAndContinueLater.states.default:
        icon = defaultIcon;
        text = 'Save & Continue Later';
        break;
      case this.saveAndContinueLater.states.saved:
        icon = savedIcon;
        text = 'Answers saved';
        // this.handleSaveSuccess();
        break;
      case this.saveAndContinueLater.states.error:
        icon = errorIcon;
        text = 'Answers not saved';
        // this.handleSaveFailure();
        break;
      default:
        icon = defaultIcon;
        text = 'Save & Continue Later';
        console.info('No such state implemented:', newState); // eslint-disable-line
        break;
    }

    progressSacl.setAttribute('data-tooltip-msg', text);
    stateElement.innerHTML = `<span class="sacl-state-icon">${icon}</span>`;
  }

  // This will be used in JotForm common to execute new SCL flow.
  asyncInitSaveAndContinueLaterFlow(getSCLManager) {
    const newSCLManager = getSCLManager({
      formID: this.formID,
      triggerButtonSelector: '.jfProgress-sacl',
      onStateChange: this.onSCLStateChange,
      hiddenSubmit: this.hiddenSubmit,
      localConfiguration: this.continueLater
    });
    if (newSCLManager && this.saveAndContinueLater) { // Lets remove existing ones..
      this.saveAndContinueLater = newSCLManager; // should have same methods inside
    }
  }

  initSaveAndContinueLater() {
    this.saveAndContinueLater = new SaveAndContinueLater(this.continueLater, this.hiddenSubmit, this.findEmailAnswer, this.formID, this.apiURL, this.tranlatedTexts);
  }

  isJsonString(str) {
    try {
      var o = JSON.parse(str);
      // Handle non-exception-throwing cases:
      // Neither JSON.parse(false) or JSON.parse(1234) throw errors, hence the type-checking,
      // but... JSON.parse(null) returns 'null', and typeof null === "object",
      // so we must check for that, too.
      if (o && typeof o === 'object' && o !== null) {
        return true;
      }
    } catch (e) {
      console.log(e);
    }

    return false;
  }
}

global.CardLayout = Cards;
